import { Component, createContext, useContext, useEffect, useMemo, useRef } from "react";
import lightGallery from "lightgallery";
import "@tecnobit-srl/ui-lightgallery/css";
import { Style } from "@tecnobit-srl/styles-manager";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region ../../../../../node_modules/lightgallery/plugins/thumbnail/lg-thumbnail.es5.js
/*!
* lightgallery | 3.0.0 | October 9th 2026
* http://www.lightgalleryjs.com/
* Copyright (c) 2020 Sachin Neravath;
* @license GPLv3
*/
var SPRING_SETTLE_DAMPING$1 = 1;
var SPRING_NATURAL_FREQUENCY$1 = 12;
var DECELERATION_RATE$1 = .995;
function project$1(velocity, decelerationRate = DECELERATION_RATE$1) {
	return velocity * decelerationRate / (1 - decelerationRate);
}
function stepSpring$1(state, target, dtMs, { dampingRatio = SPRING_SETTLE_DAMPING$1, naturalFrequency = SPRING_NATURAL_FREQUENCY$1 } = {}) {
	const t = dtMs / 1e3;
	const w0 = naturalFrequency;
	const zeta = Math.min(dampingRatio, 1);
	const x0 = state.position - target;
	const v0 = state.velocity * 1e3;
	const decay = Math.exp(-zeta * w0 * t);
	let x;
	let v;
	if (zeta < 1) {
		const wd = w0 * Math.sqrt(1 - zeta * zeta);
		const a = x0;
		const b = (v0 + zeta * w0 * x0) / wd;
		const cos = Math.cos(wd * t);
		const sin = Math.sin(wd * t);
		x = decay * (a * cos + b * sin);
		v = decay * ((b * wd - zeta * w0 * a) * cos - (a * wd + zeta * w0 * b) * sin);
	} else {
		const b = v0 + w0 * x0;
		x = decay * (x0 + b * t);
		v = decay * (b - w0 * (x0 + b * t));
	}
	return {
		position: target + x,
		velocity: v / 1e3
	};
}
function isSpringSettled$1(state, target, restDelta = .3, restVelocity = .012) {
	return Math.abs(state.position - target) < restDelta && Math.abs(state.velocity) < restVelocity;
}
var SLIDE_EDGE_FRICTION = .35;
var thumbnailDefaultIcons = { toggleThumbnails: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"currentColor\"><path transform=\"translate(0, 960) scale(1, -1)\" d=\"M682 84.667v172h172v-172h-172zM682 340.667v172h172v-172h-172zM426 596.667v172h172v-172h-172zM682 768.667h172v-172h-172v172zM426 340.667v172h172v-172h-172zM170 340.667v172h172v-172h-172zM170 84.667v172h172v-172h-172zM426 84.667v172h172v-172h-172zM170 596.667v172h172v-172h-172z\"/></svg>" };
var __defProp$1$5 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$1$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$1$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1$5 = (obj, key, value) => key in obj ? __defProp$1$5(obj, key, {
	enumerable: true,
	configurable: true,
	writable: true,
	value
}) : obj[key] = value;
var __spreadValues$1$5 = (a, b) => {
	for (var prop in b || (b = {})) if (__hasOwnProp$1$5.call(b, prop)) __defNormalProp$1$5(a, prop, b[prop]);
	if (__getOwnPropSymbols$1$5) {
		for (var prop of __getOwnPropSymbols$1$5(b)) if (__propIsEnum$1$5.call(b, prop)) __defNormalProp$1$5(a, prop, b[prop]);
	}
	return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __objRest = (source, exclude) => {
	var target = {};
	for (var prop in source) if (__hasOwnProp$1$5.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
	if (source != null && __getOwnPropSymbols$1$5) {
		for (var prop of __getOwnPropSymbols$1$5(source)) if (exclude.indexOf(prop) < 0 && __propIsEnum$1$5.call(source, prop)) target[prop] = source[prop];
	}
	return target;
};
function getElasticThumbTranslate(raw, totalWidth, stripWidth, friction = SLIDE_EDGE_FRICTION) {
	const max = Math.max(0, totalWidth - stripWidth);
	if (raw < 0) return raw * friction;
	if (raw > max) return max + (raw - max) * friction;
	return raw;
}
function getThumbTotalWidth(count, thumbWidth, thumbMargin) {
	return count * (thumbWidth + thumbMargin);
}
function clampThumbTranslate(translate, totalWidth, stripWidth) {
	const max = Math.max(0, totalWidth - stripWidth);
	return Math.min(Math.max(translate, 0), max);
}
function getThumbWindow(options) {
	const { translate, stripWidth, thumbWidth, thumbMargin, count } = options;
	const unit = thumbWidth + thumbMargin;
	if (count <= 0 || unit <= 0) return {
		start: 0,
		end: -1,
		leadingPad: 0,
		trailingPad: 0
	};
	const overscan = options.overscan === "auto" || options.overscan === void 0 ? Math.max(1, Math.ceil(stripWidth / unit)) : Math.max(0, options.overscan);
	const clampedTranslate = clampThumbTranslate(translate, getThumbTotalWidth(count, thumbWidth, thumbMargin), stripWidth);
	const firstVisible = Math.floor(clampedTranslate / unit);
	const lastVisible = Math.ceil((clampedTranslate + stripWidth) / unit) - 1;
	const start = Math.max(0, firstVisible - overscan);
	const end = Math.min(count - 1, lastVisible + overscan);
	return {
		start,
		end,
		leadingPad: start * unit,
		trailingPad: (count - 1 - end) * unit
	};
}
function getThumbCorridorWindow(options) {
	const _a = options, { from, to } = _a, geometry = __objRest(_a, ["from", "to"]);
	const a = getThumbWindow(__spreadProps$1(__spreadValues$1$5({}, geometry), { translate: from }));
	const b = getThumbWindow(__spreadProps$1(__spreadValues$1$5({}, geometry), { translate: to }));
	const start = Math.min(a.start, b.start);
	const end = Math.max(a.end, b.end);
	const unit = options.thumbWidth + options.thumbMargin;
	if (end < start) return {
		start: 0,
		end: -1,
		leadingPad: 0,
		trailingPad: 0
	};
	return {
		start,
		end,
		leadingPad: start * unit,
		trailingPad: (options.count - 1 - end) * unit
	};
}
function getScrubThumbIndex(translate, totalWidth, stripWidth, count) {
	const max = totalWidth - stripWidth;
	if (count <= 1 || max <= 0) return 0;
	const clamped = clampThumbTranslate(translate, totalWidth, stripWidth);
	return Math.round(clamped / max * (count - 1));
}
function getActiveThumbTranslate(index, thumbWidth, thumbMargin, stripWidth, totalWidth, pagerPosition, direction = "ltr") {
	const logicalPosition = direction === "rtl" && pagerPosition !== "middle" ? pagerPosition === "left" ? "right" : "left" : pagerPosition;
	let position = 0;
	switch (logicalPosition) {
		case "left":
			position = 0;
			break;
		case "middle":
			position = stripWidth / 2 - thumbWidth / 2;
			break;
		case "right": position = stripWidth - thumbWidth;
	}
	return clampThumbTranslate((thumbWidth + thumbMargin) * index - 1 - position, totalWidth, stripWidth);
}
var VELOCITY_WINDOW_MS$1 = 100;
var MIN_DISPLACEMENT$1 = 1;
var MIN_WINDOW_SPAN_MS$1 = 5;
function pushVelocitySample$1(samples, sample, windowMs = VELOCITY_WINDOW_MS$1) {
	return [...samples.filter((s) => sample.t - s.t <= windowMs), sample];
}
function getWindowedVelocity$1(samples, releaseTime, windowMs = VELOCITY_WINDOW_MS$1) {
	const recent = samples.filter((s) => releaseTime - s.t <= windowMs);
	if (recent.length < 2) return {
		x: 0,
		y: 0
	};
	const first = recent[0];
	const last = recent[recent.length - 1];
	const dt = last.t - first.t;
	if (dt < MIN_WINDOW_SPAN_MS$1) return {
		x: 0,
		y: 0
	};
	const dx = last.x - first.x;
	const dy = last.y - first.y;
	return {
		x: Math.abs(dx) > MIN_DISPLACEMENT$1 ? dx / dt : 0,
		y: Math.abs(dy) > MIN_DISPLACEMENT$1 ? dy / dt : 0
	};
}
var MAX_FRAME_MS$1 = 64;
function runSprings$1(tracks, onFrame, onDone) {
	let raf = 0;
	let last = Date.now();
	const states = tracks.map((t) => ({
		position: t.from,
		velocity: t.velocity
	}));
	const frame = () => {
		const now = Date.now();
		const dt = Math.min(Math.max(now - last, 0), MAX_FRAME_MS$1);
		last = now;
		let settled = true;
		tracks.forEach((t, i) => {
			states[i] = stepSpring$1(states[i], t.target, dt, t);
			if (!isSpringSettled$1(states[i], t.target)) settled = false;
		});
		if (settled) {
			onFrame(tracks.map((t) => t.target));
			onDone?.();
			return;
		}
		onFrame(states.map((s) => s.position));
		raf = requestAnimationFrame(frame);
	};
	raf = requestAnimationFrame(frame);
	return () => cancelAnimationFrame(raf);
}
var thumbnailsSettings = {
	thumbnail: true,
	animateThumb: true,
	currentPagerPosition: "middle",
	alignThumbnails: "middle",
	thumbWidth: 100,
	thumbHeight: "80px",
	thumbMargin: 5,
	appendThumbnailsTo: ".lg-components",
	toggleThumb: false,
	enableThumbDrag: true,
	enableThumbSwipe: true,
	thumbnailSwipeThreshold: 10,
	scrubThumbnails: false,
	loadYouTubeThumbnail: true,
	youTubeThumbSize: 1
};
var lGEvents$3 = {
	containerResize: "lgContainerResize",
	updateSlides: "lgUpdateSlides",
	beforeOpen: "lgBeforeOpen",
	afterOpen: "lgAfterOpen",
	beforeSlide: "lgBeforeSlide"
};
var __defProp$6 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, {
	enumerable: true,
	configurable: true,
	writable: true,
	value
}) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
	for (var prop in b || (b = {})) if (__hasOwnProp$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
	if (__getOwnPropSymbols$6) {
		for (var prop of __getOwnPropSymbols$6(b)) if (__propIsEnum$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
	}
	return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var Thumbnail = class {
	constructor(instance, $LG) {
		this.thumbOuterWidth = 0;
		this.thumbTotalWidth = 0;
		this.translateX = 0;
		this.thumbClickable = false;
		this.instantThumb = false;
		this.dragSamples = [];
		this.liveTranslateX = 0;
		this.scrubActive = false;
		this.scrubIndex = -1;
		this.core = instance;
		this.$LG = $LG;
		return this;
	}
	init() {
		this.core.registerDefaultIcons(thumbnailDefaultIcons);
		this.settings = __spreadValues$6(__spreadValues$6({}, thumbnailsSettings), this.core.settings);
		this.thumbOuterWidth = 0;
		this.thumbTotalWidth = getThumbTotalWidth(this.core.galleryItems.length, this.settings.thumbWidth, this.settings.thumbMargin);
		this.translateX = 0;
		this.setAnimateThumbStyles();
		if (!this.core.settings.allowMediaOverlap) this.settings.toggleThumb = false;
		if (this.settings.thumbnail) {
			this.build();
			if (this.settings.animateThumb) {
				if (this.settings.enableThumbDrag) this.enableThumbDrag();
				if (this.settings.enableThumbSwipe) this.enableThumbSwipe();
				this.thumbClickable = false;
			} else this.thumbClickable = true;
			this.toggleThumbBar();
			this.thumbKeyPress();
		}
	}
	build() {
		this.setThumbMarkup();
		this.manageActiveClassOnSlideChange();
		this.$lgThumb.first().on("click.lg touchend.lg", (e) => {
			const $target = this.$LG(e.target);
			if (!$target.hasAttribute("data-lg-item-id")) return;
			setTimeout(() => {
				if (this.thumbClickable && !this.core.lgBusy) {
					const index = parseInt($target.attr("data-lg-item-id"));
					this.core.slide(index, false, true, false);
				}
			}, 50);
		});
		this.core.LGel.on(`${lGEvents$3.beforeSlide}.thumb`, (event) => {
			if (this.scrubActive) return;
			const { index } = event.detail;
			this.animateThumb(index);
		});
		this.core.LGel.on(`${lGEvents$3.beforeOpen}.thumb`, () => {
			this.thumbOuterWidth = this.core.outer.get().offsetWidth;
			this.instantThumb = true;
		});
		this.core.LGel.on(`${lGEvents$3.afterOpen}.thumb`, () => {
			this.instantThumb = false;
		});
		this.core.LGel.on(`${lGEvents$3.updateSlides}.thumb`, () => {
			this.rebuildThumbnails();
		});
		this.core.LGel.on(`${lGEvents$3.containerResize}.thumb`, () => {
			if (!this.core.lgOpened) return;
			setTimeout(() => {
				this.thumbOuterWidth = this.core.outer.get().offsetWidth;
				this.animateThumb(this.core.index);
				this.thumbOuterWidth = this.core.outer.get().offsetWidth;
			}, 50);
		});
	}
	setThumbMarkup() {
		let thumbOuterClassNames = "lg-thumb-outer ";
		if (this.settings.alignThumbnails) thumbOuterClassNames += `lg-thumb-align-${this.settings.alignThumbnails}`;
		const html = `<div class="${thumbOuterClassNames}">
        <div class="lg-thumb lg-group">
        </div>
        </div>`;
		this.core.outer.addClass("lg-has-thumb");
		if (this.settings.appendThumbnailsTo === ".lg-components") this.core.$lgComponents.append(html);
		else this.core.outer.append(html);
		this.$thumbOuter = this.core.outer.find(".lg-thumb-outer").first();
		this.$lgThumb = this.core.outer.find(".lg-thumb").first();
		if (this.settings.animateThumb) this.core.outer.find(".lg-thumb").css("transition-duration", this.core.settings.speed + "ms").css("width", this.thumbTotalWidth + "px").css("position", "relative");
		this.renderThumbItems();
	}
	enableThumbDrag() {
		let thumbDragUtils = {
			cords: {
				startX: 0,
				endX: 0
			},
			isMoved: false,
			newTranslateX: 0,
			startTime: /* @__PURE__ */ new Date(),
			endTime: /* @__PURE__ */ new Date(),
			touchMoveTime: 0
		};
		let isDragging = false;
		this.$thumbOuter.addClass("lg-grab");
		this.core.outer.find(".lg-thumb").first().on("mousedown.lg.thumb", (e) => {
			if (this.thumbTotalWidth > this.thumbOuterWidth) {
				e.preventDefault();
				this.onThumbDragStart(e.pageX);
				thumbDragUtils.cords.startX = e.pageX;
				thumbDragUtils.startTime = /* @__PURE__ */ new Date();
				this.thumbClickable = false;
				isDragging = true;
				this.core.outer.get().scrollLeft += 1;
				this.core.outer.get().scrollLeft -= 1;
				this.$thumbOuter.removeClass("lg-grab").addClass("lg-grabbing");
			}
		});
		this.$LG(window).on(`mousemove.lg.thumb.global${this.core.lgId}`, (e) => {
			if (!this.core.lgOpened) return;
			if (isDragging) {
				thumbDragUtils.cords.endX = e.pageX;
				thumbDragUtils = this.onThumbTouchMove(thumbDragUtils);
			}
		});
		this.$LG(window).on(`mouseup.lg.thumb.global${this.core.lgId}`, () => {
			if (!this.core.lgOpened) return;
			if (thumbDragUtils.isMoved) thumbDragUtils = this.onThumbTouchEnd(thumbDragUtils);
			else {
				this.thumbClickable = true;
				this.endScrub();
			}
			if (isDragging) {
				isDragging = false;
				this.$thumbOuter.removeClass("lg-grabbing").addClass("lg-grab");
			}
		});
	}
	enableThumbSwipe() {
		let thumbDragUtils = {
			cords: {
				startX: 0,
				endX: 0
			},
			isMoved: false,
			newTranslateX: 0,
			startTime: /* @__PURE__ */ new Date(),
			endTime: /* @__PURE__ */ new Date(),
			touchMoveTime: 0
		};
		this.$lgThumb.on("touchstart.lg", (e) => {
			if (this.thumbTotalWidth > this.thumbOuterWidth) {
				e.preventDefault();
				this.onThumbDragStart(e.targetTouches[0].pageX);
				thumbDragUtils.cords.startX = e.targetTouches[0].pageX;
				this.thumbClickable = false;
				thumbDragUtils.startTime = /* @__PURE__ */ new Date();
			}
		});
		this.$lgThumb.on("touchmove.lg", (e) => {
			if (this.thumbTotalWidth > this.thumbOuterWidth) {
				e.preventDefault();
				thumbDragUtils.cords.endX = e.targetTouches[0].pageX;
				thumbDragUtils = this.onThumbTouchMove(thumbDragUtils);
			}
		});
		this.$lgThumb.on("touchend.lg", () => {
			if (thumbDragUtils.isMoved) thumbDragUtils = this.onThumbTouchEnd(thumbDragUtils);
			else {
				this.thumbClickable = true;
				this.endScrub();
			}
		});
	}
	rebuildThumbnails() {
		this.$thumbOuter.addClass("lg-rebuilding-thumbnails");
		setTimeout(() => {
			this.thumbTotalWidth = getThumbTotalWidth(this.core.galleryItems.length, this.settings.thumbWidth, this.settings.thumbMargin);
			this.$lgThumb.css("width", this.thumbTotalWidth + "px");
			this.$lgThumb.empty();
			this.renderThumbItems();
			this.animateThumb(this.core.index);
		}, 50);
		setTimeout(() => {
			this.$thumbOuter.removeClass("lg-rebuilding-thumbnails");
		}, 200);
	}
	setTranslate(value) {
		const x = this.isRtl() ? value : -value;
		this.$lgThumb.css("transform", "translate3d(" + x + "px, 0px, 0px)");
	}
	isRtl() {
		return this.core.settings.direction === "rtl";
	}
	getPossibleTransformX(left) {
		return clampThumbTranslate(left, this.thumbTotalWidth, this.thumbOuterWidth);
	}
	animateThumb(index) {
		if (this.cancelThumbSpring) {
			this.cancelThumbSpring();
			this.cancelThumbSpring = void 0;
		}
		this.$lgThumb.css("transition-duration", this.instantThumb ? "0ms" : this.core.settings.speed + "ms");
		if (this.settings.animateThumb) {
			this.translateX = getActiveThumbTranslate(index, this.settings.thumbWidth, this.settings.thumbMargin, this.thumbOuterWidth, this.thumbTotalWidth, this.settings.currentPagerPosition, this.isRtl() ? "rtl" : "ltr");
			this.liveTranslateX = this.translateX;
			this.setTranslate(this.translateX);
			if (this.isThumbWindowed()) this.renderThumbItems(index);
		}
	}
	canScrub() {
		return this.settings.scrubThumbnails && this.settings.animateThumb;
	}
	/**
	* A scrub session starts on the first actual strip movement and
	* ends when the release glide settles (or the plugin dies). While
	* it runs: slide transitions are visually off (`lg-thumb-scrubbing`
	* CSS), the core's transition timers collapse (`speed` 0) so the
	* landed slide's content loads without the navigation lag, and the
	* strip's own slide-change re-centering stands down.
	*/
	beginScrub() {
		if (this.scrubActive) return;
		this.scrubActive = true;
		this.scrubIndex = this.core.index;
		this.scrubSavedSpeed = this.core.settings.speed;
		this.core.settings.speed = 0;
		this.core.outer.addClass("lg-thumb-scrubbing");
	}
	endScrub() {
		if (!this.scrubActive) return;
		this.scrubActive = false;
		this.scrubIndex = -1;
		if (this.scrubSavedSpeed !== void 0) {
			this.core.settings.speed = this.scrubSavedSpeed;
			this.scrubSavedSpeed = void 0;
		}
		this.core.outer.removeClass("lg-thumb-scrubbing");
	}
	/** Live translate → slide, on drag frames and glide frames alike. */
	scrubTo(translate) {
		const index = getScrubThumbIndex(translate, this.thumbTotalWidth, this.thumbOuterWidth, this.core.galleryItems.length);
		if (index === this.scrubIndex) return;
		this.scrubIndex = index;
		this.core.lgBusy = false;
		this.core.slide(index, true, true, false);
	}
	/**
	* Drag-start seam (strip physics): a press mid-glide takes over
	* from the live position, and the velocity window restarts.
	*/
	onThumbDragStart(pageX) {
		if (this.cancelThumbSpring) {
			this.cancelThumbSpring();
			this.cancelThumbSpring = void 0;
			this.translateX = this.liveTranslateX;
		}
		this.liveTranslateX = this.translateX;
		this.dragSamples = pushVelocitySample$1([], {
			x: pageX,
			y: 0,
			t: Date.now()
		});
	}
	onThumbTouchMove(thumbDragUtils) {
		thumbDragUtils.isMoved = true;
		thumbDragUtils.touchMoveTime = (/* @__PURE__ */ new Date()).valueOf();
		this.dragSamples = pushVelocitySample$1(this.dragSamples, {
			x: thumbDragUtils.cords.endX,
			y: 0,
			t: Date.now()
		});
		const dragDelta = thumbDragUtils.cords.endX - thumbDragUtils.cords.startX;
		thumbDragUtils.newTranslateX = getElasticThumbTranslate(this.translateX + (this.isRtl() ? dragDelta : -dragDelta), this.thumbTotalWidth, this.thumbOuterWidth);
		this.liveTranslateX = thumbDragUtils.newTranslateX;
		this.setTranslate(thumbDragUtils.newTranslateX);
		this.$thumbOuter.addClass("lg-dragging");
		if (this.canScrub() && (this.scrubActive || Math.abs(dragDelta) >= this.settings.thumbnailSwipeThreshold)) {
			this.beginScrub();
			this.scrubTo(this.liveTranslateX);
		}
		if (this.isThumbWindowed() && this.renderedThumbWindow) {
			const rendered = this.renderedThumbWindow;
			const covered = this.getPossibleTransformX(this.liveTranslateX);
			if (covered < rendered.leadingPad || covered + this.thumbOuterWidth > this.thumbTotalWidth - rendered.trailingPad) this.renderThumbItems(this.core.index, {
				from: this.liveTranslateX,
				to: this.liveTranslateX
			});
		}
		return thumbDragUtils;
	}
	onThumbTouchEnd(thumbDragUtils) {
		thumbDragUtils.isMoved = false;
		thumbDragUtils.endTime = /* @__PURE__ */ new Date();
		this.$thumbOuter.removeClass("lg-dragging");
		if (Math.abs(thumbDragUtils.cords.endX - thumbDragUtils.cords.startX) < this.settings.thumbnailSwipeThreshold) {
			this.thumbClickable = true;
			this.endScrub();
			this.liveTranslateX = this.translateX;
			this.$lgThumb.css("transition-duration", this.core.settings.speed + "ms");
			this.setTranslate(this.translateX);
			return thumbDragUtils;
		}
		const pointerVelocityX = getWindowedVelocity$1(this.dragSamples, Date.now()).x;
		const translateVelocity = this.isRtl() ? pointerVelocityX : -pointerVelocityX;
		const from = this.liveTranslateX;
		const target = this.getPossibleTransformX(from + project$1(translateVelocity));
		this.$lgThumb.css("transition-duration", "0ms");
		if (this.isThumbWindowed()) this.renderThumbItems(this.core.index, {
			from,
			to: target
		});
		this.cancelThumbSpring = runSprings$1([{
			from,
			velocity: translateVelocity,
			target
		}], ([value]) => {
			this.liveTranslateX = value;
			this.setTranslate(value);
			if (this.scrubActive) this.scrubTo(value);
		}, () => {
			this.cancelThumbSpring = void 0;
			this.translateX = target;
			this.endScrub();
			this.$lgThumb.css("transition-duration", this.core.settings.speed + "ms");
			if (this.isThumbWindowed()) this.renderThumbItems();
		});
		return thumbDragUtils;
	}
	getThumbHtml(thumb, index, alt, activeIndex = this.core.index) {
		const slideVideoInfo = this.core.galleryItems[index].__slideVideoInfo || {};
		let thumbImg;
		if (slideVideoInfo.youtube) {
			if (this.settings.loadYouTubeThumbnail) thumbImg = "//img.youtube.com/vi/" + slideVideoInfo.youtube[1] + "/" + this.settings.youTubeThumbSize + ".jpg";
			else thumbImg = thumb;
		} else thumbImg = thumb;
		const div = document.createElement("div");
		div.setAttribute("data-lg-item-id", index + "");
		div.className = `lg-thumb-item ${index === activeIndex ? "active" : ""}`;
		const marginSide = this.isRtl() ? "margin-left" : "margin-right";
		div.style.cssText = `width: ${this.settings.thumbWidth}px; height: ${this.settings.thumbHeight}; ${marginSide}: ${this.settings.thumbMargin}px;`;
		const img = document.createElement("img");
		img.alt = alt || "";
		img.setAttribute("data-lg-item-id", index + "");
		img.setAttribute("loading", "lazy");
		img.setAttribute("decoding", "async");
		img.src = thumbImg;
		div.appendChild(img);
		return div;
	}
	/**
	* True when the strip renders only a window of thumbs
	* (virtualization.thumbs).
	*/
	isThumbWindowed() {
		var _a;
		return ((_a = this.core.settings.virtualization) == null ? void 0 : _a.thumbs) !== void 0;
	}
	/**
	* (Re)build the strip contents. Classic mode appends every thumb once;
	* windowed mode renders the visible range plus overscan with spacers
	* preserving the strip geometry, and re-runs at commit points only
	* (open, slide change, drag release, resize, updateSlides), never per
	* pointer move.
	*/
	renderThumbItems(activeIndex = this.core.index, corridor) {
		var _a;
		const items = this.core.galleryItems;
		if (!this.isThumbWindowed()) {
			this.setThumbItemHtml(items);
			return;
		}
		const geometry = {
			stripWidth: this.thumbOuterWidth,
			thumbWidth: this.settings.thumbWidth,
			thumbMargin: this.settings.thumbMargin,
			count: items.length,
			overscan: (_a = this.core.settings.virtualization) == null ? void 0 : _a.thumbs
		};
		const thumbWindow = corridor ? getThumbCorridorWindow(__spreadValues$6(__spreadValues$6({}, geometry), corridor)) : getThumbWindow(__spreadProps(__spreadValues$6({}, geometry), { translate: this.translateX }));
		this.renderedThumbWindow = thumbWindow;
		this.$lgThumb.empty();
		if (thumbWindow.leadingPad > 0) this.$lgThumb.append(`<div class="lg-thumb-spacer" aria-hidden="true" style="width: ${thumbWindow.leadingPad}px;"></div>`);
		for (let i = thumbWindow.start; i <= thumbWindow.end; i++) this.$lgThumb.append(this.getThumbHtml(items[i].thumb, i, items[i].alt, activeIndex));
		if (thumbWindow.trailingPad > 0) this.$lgThumb.append(`<div class="lg-thumb-spacer" aria-hidden="true" style="width: ${thumbWindow.trailingPad}px;"></div>`);
	}
	setThumbItemHtml(items) {
		for (let i = 0; i < items.length; i++) {
			const thumb = this.getThumbHtml(items[i].thumb, i, items[i].alt);
			this.$lgThumb.append(thumb);
		}
	}
	setAnimateThumbStyles() {
		if (this.settings.animateThumb) this.core.outer.addClass("lg-animate-thumb");
	}
	manageActiveClassOnSlideChange() {
		this.core.LGel.on(`${lGEvents$3.beforeSlide}.thumb`, (event) => {
			const { index } = event.detail;
			this.core.outer.find(".lg-thumb-item").removeClass("active");
			this.core.outer.find(`.lg-thumb-item[data-lg-item-id="${index}"]`).addClass("active");
		});
	}
	toggleThumbBar() {
		var _a, _b;
		if (this.settings.toggleThumb) {
			this.core.outer.addClass("lg-can-toggle");
			this.core.$toolbar.append("<button type=\"button\" aria-label=\"" + ((_b = (_a = this.settings.thumbnailPluginStrings) == null ? void 0 : _a.toggleThumbnails) != null ? _b : this.core.settings.strings.toggleThumbnails) + "\" class=\"lg-toggle-thumb lg-icon\"></button>");
			this.core.outer.find(".lg-toggle-thumb").first().on("click.lg", () => {
				this.core.outer.toggleClass("lg-components-open");
			});
		}
	}
	thumbKeyPress() {
		this.$LG(window).on(`keydown.lg.thumb.global${this.core.lgId}`, (e) => {
			if (!this.core.lgOpened || !this.settings.toggleThumb) return;
			if (e.keyCode === 38) {
				e.preventDefault();
				this.core.outer.addClass("lg-components-open");
			} else if (e.keyCode === 40) {
				e.preventDefault();
				this.core.outer.removeClass("lg-components-open");
			}
		});
	}
	destroy() {
		this.endScrub();
		if (this.cancelThumbSpring) {
			this.cancelThumbSpring();
			this.cancelThumbSpring = void 0;
		}
		if (this.settings.thumbnail) {
			this.$LG(window).off(`.lg.thumb.global${this.core.lgId}`);
			this.core.LGel.off(".lg.thumb");
			this.core.LGel.off(".thumb");
			this.$thumbOuter.remove();
			this.core.outer.removeClass("lg-has-thumb");
		}
	}
};
//#endregion
//#region ../../../../../node_modules/lightgallery/plugins/zoom/lg-zoom.es5.js
/*!
* lightgallery | 3.0.0 | October 9th 2026
* http://www.lightgalleryjs.com/
* Copyright (c) 2020 Sachin Neravath;
* @license GPLv3
*/
var SPRING_SETTLE_DAMPING = 1;
var SPRING_BOUNCE_DAMPING = .82;
var SPRING_NATURAL_FREQUENCY = 12;
var DECELERATION_RATE = .995;
function project(velocity, decelerationRate = DECELERATION_RATE) {
	return velocity * decelerationRate / (1 - decelerationRate);
}
function stepSpring(state, target, dtMs, { dampingRatio = SPRING_SETTLE_DAMPING, naturalFrequency = SPRING_NATURAL_FREQUENCY } = {}) {
	const t = dtMs / 1e3;
	const w0 = naturalFrequency;
	const zeta = Math.min(dampingRatio, 1);
	const x0 = state.position - target;
	const v0 = state.velocity * 1e3;
	const decay = Math.exp(-zeta * w0 * t);
	let x;
	let v;
	if (zeta < 1) {
		const wd = w0 * Math.sqrt(1 - zeta * zeta);
		const a = x0;
		const b = (v0 + zeta * w0 * x0) / wd;
		const cos = Math.cos(wd * t);
		const sin = Math.sin(wd * t);
		x = decay * (a * cos + b * sin);
		v = decay * ((b * wd - zeta * w0 * a) * cos - (a * wd + zeta * w0 * b) * sin);
	} else {
		const b = v0 + w0 * x0;
		x = decay * (x0 + b * t);
		v = decay * (b - w0 * (x0 + b * t));
	}
	return {
		position: target + x,
		velocity: v / 1e3
	};
}
function isSpringSettled(state, target, restDelta = .3, restVelocity = .012) {
	return Math.abs(state.position - target) < restDelta && Math.abs(state.velocity) < restVelocity;
}
function parseImageSize(lgSize, viewportWidth) {
	if (!lgSize) return;
	let size = lgSize;
	const responsiveSizes = lgSize.split(",");
	if (responsiveSizes[1]) for (let i = 0; i < responsiveSizes.length; i++) {
		const candidate = responsiveSizes[i].trim();
		if (parseInt(candidate.split("-")[2], 10) > viewportWidth) {
			size = candidate;
			break;
		}
		if (i === responsiveSizes.length - 1) size = candidate;
	}
	const parts = size.trim().split("-");
	const width = parseInt(parts[0], 10);
	const height = parseInt(parts[1], 10);
	if (!Number.isFinite(width) || !Number.isFinite(height)) return;
	return {
		width,
		height
	};
}
function fitImageSize(size, containerWidth, containerHeight) {
	const maxWidth = Math.min(containerWidth, size.width);
	const maxHeight = Math.min(containerHeight, size.height);
	const ratio = Math.min(maxWidth / size.width, maxHeight / size.height);
	return {
		width: size.width * ratio,
		height: size.height * ratio
	};
}
var zoomDefaultIcons = {
	zoomIn: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"currentColor\"><path transform=\"translate(0, 960) scale(1, -1)\" d=\"M512 512.667h-86v-86h-42v86h-86v42h86v86h42v-86h86v-42zM406 340.667q80 0 136 56t56 136-56 136-136 56-136-56-56-136 56-136 136-56zM662 340.667l212-212-64-64-212 212v34l-12 12q-76-66-180-66-116 0-197 80t-81 196 81 197 197 81 196-81 80-197q0-104-66-180l12-12h34z\"/></svg>",
	zoomOut: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"currentColor\"><path transform=\"translate(0, 960) scale(1, -1)\" d=\"M298 554.667h214v-42h-214v42zM406 340.667q80 0 136 56t56 136-56 136-136 56-136-56-56-136 56-136 136-56zM662 340.667l212-212-64-64-212 212v34l-12 12q-76-66-180-66-116 0-197 80t-81 196 81 197 197 81 196-81 80-197q0-104-66-180l12-12h34z\"/></svg>",
	actualSize: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"currentColor\"><path transform=\"translate(0, 960) scale(1, -1)\" d=\"M384 853.334h426.667q53 0 90.5-37.5t37.5-90.5v-426.667q0-53-37.5-90.5t-90.5-37.5h-426.667q-53 0-90.5 37.5t-37.5 90.5v426.667q0 53 37.5 90.5t90.5 37.5zM170.667 675.334v-547.333q0-17.667 12.5-30.167t30.167-12.5h547.333q-13.333-37.667-46.333-61.5t-74.333-23.833h-426.667q-53 0-90.5 37.5t-37.5 90.5v426.667q0 41.333 23.833 74.333t61.5 46.333zM810.667 768h-426.667q-17.667 0-30.167-12.5t-12.5-30.167v-426.667q0-17.667 12.5-30.167t30.167-12.5h426.667q17.667 0 30.167 12.5t12.5 30.167v426.667q0 17.667-12.5 30.167t-30.167 12.5z\"/></svg>"
};
function getPanBounds(imageWidth, imageHeight, containerWidth, containerHeight, scale) {
	return {
		maxX: Math.max(0, (imageWidth * scale - containerWidth) / 2),
		maxY: Math.max(0, (imageHeight * scale - containerHeight) / 2)
	};
}
function getActualSizeScale(naturalWidth, renderedWidth) {
	if (!renderedWidth) return 2;
	return naturalWidth / renderedWidth || 2;
}
function getPointZoomPan(point, prevPan, prevScale, newScale) {
	const ratio = newScale / prevScale;
	return {
		x: point.x - (point.x - prevPan.x) * ratio,
		y: point.y - (point.y - prevPan.y) * ratio
	};
}
function clampPanToStage(pan, bounds, stageBottomExtra) {
	const floorY = Math.min(-bounds.maxY + stageBottomExtra, bounds.maxY);
	return {
		x: Math.min(Math.max(pan.x, -bounds.maxX), bounds.maxX),
		y: Math.min(Math.max(pan.y, floorY), bounds.maxY)
	};
}
function getPinchPan(currentMid, startMid, startPan, startScale, scale) {
	const projected = getPointZoomPan(startMid, startPan, startScale, scale);
	return {
		x: projected.x + (currentMid.x - startMid.x),
		y: projected.y + (currentMid.y - startMid.y)
	};
}
function getPointerDistance(a, b) {
	return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y));
}
var PINCH_UNDER_FRICTION = .15;
var PINCH_OVER_FRICTION = .05;
function getPinchScale(startDistance, currentDistance, startScale, maxScale, infiniteZoom, pinchToCloseArmed = false) {
	if (startDistance <= 0) return startScale;
	let scale = currentDistance / startDistance * startScale;
	if (scale < 1 && !pinchToCloseArmed) scale = 1 + (scale - 1) * PINCH_UNDER_FRICTION;
	const cap = Math.max(maxScale, 1);
	if (!infiniteZoom && scale > cap) scale = cap + (scale - cap) * PINCH_OVER_FRICTION;
	return scale;
}
function shouldCloseOnPinch(input) {
	return input.pinchToClose && input.closable && input.scale < 1 && input.maxGestureScale <= 1;
}
function parseSrcset(srcset) {
	const candidates = [];
	if (typeof srcset !== "string") return candidates;
	for (const entry of srcset.split(",")) {
		const parts = entry.trim().split(/\s+/);
		const url = parts[0];
		if (!url) continue;
		const descriptor = parts[1];
		if (!descriptor) {
			candidates.push({
				url,
				density: 1
			});
			continue;
		}
		const value = parseFloat(descriptor);
		if (Number.isNaN(value) || value <= 0) continue;
		if (descriptor.endsWith("w")) candidates.push({
			url,
			width: value
		});
		else if (descriptor.endsWith("x")) candidates.push({
			url,
			density: value
		});
	}
	return candidates;
}
function matchesMedia(media, viewport) {
	if (!media) return true;
	const condition = /^\(\s*(min|max)-width:\s*([\d.]+)px\s*\)$/.exec(media.trim());
	if (!condition) return false;
	const bound = parseFloat(condition[2]);
	return condition[1] === "min" ? viewport.width >= bound : viewport.width <= bound;
}
function getActualSizeWidth(item, viewport, naturalWidth) {
	if (item.width) {
		const declared = parseFloat(item.width);
		if (!Number.isNaN(declared) && declared > 0) return declared;
	}
	let candidates = [];
	const sources = Array.isArray(item.sources) ? item.sources : [];
	for (const source of sources) if (matchesMedia(source.media, viewport)) {
		candidates = parseSrcset(source.srcset);
		break;
	}
	if (!candidates.length && item.srcset) candidates = parseSrcset(item.srcset);
	const widths = candidates.map((candidate) => candidate.width).filter((width) => width !== void 0);
	if (widths.length) return Math.max(...widths);
	const natural = parseImageSize(item.lgSize, viewport.width);
	if (natural && natural.width > 0) return natural.width;
	return naturalWidth;
}
var VELOCITY_WINDOW_MS = 100;
var MIN_DISPLACEMENT = 1;
var MIN_WINDOW_SPAN_MS = 5;
function pushVelocitySample(samples, sample, windowMs = VELOCITY_WINDOW_MS) {
	return [...samples.filter((s) => sample.t - s.t <= windowMs), sample];
}
function getWindowedVelocity(samples, releaseTime, windowMs = VELOCITY_WINDOW_MS) {
	const recent = samples.filter((s) => releaseTime - s.t <= windowMs);
	if (recent.length < 2) return {
		x: 0,
		y: 0
	};
	const first = recent[0];
	const last = recent[recent.length - 1];
	const dt = last.t - first.t;
	if (dt < MIN_WINDOW_SPAN_MS) return {
		x: 0,
		y: 0
	};
	const dx = last.x - first.x;
	const dy = last.y - first.y;
	return {
		x: Math.abs(dx) > MIN_DISPLACEMENT ? dx / dt : 0,
		y: Math.abs(dy) > MIN_DISPLACEMENT ? dy / dt : 0
	};
}
function getRotatedVisualSize(width, height, transform) {
	if (!transform) return {
		width,
		height
	};
	const rotate = /rotate\((-?\d+(?:\.\d+)?)deg\)/.exec(transform);
	const scale = /scale3d\((-?\d+(?:\.\d+)?)/.exec(transform);
	const fit = (scale == null ? void 0 : scale[1]) ? Math.abs(parseFloat(scale[1])) : 1;
	const normalized = (((rotate == null ? void 0 : rotate[1]) ? parseFloat(rotate[1]) : 0) % 360 + 360) % 360;
	return normalized === 90 || normalized === 270 ? {
		width: height * fit,
		height: width * fit
	} : {
		width: width * fit,
		height: height * fit
	};
}
var MAX_FRAME_MS = 64;
function runSprings(tracks, onFrame, onDone) {
	let raf = 0;
	let last = Date.now();
	const states = tracks.map((t) => ({
		position: t.from,
		velocity: t.velocity
	}));
	const frame = () => {
		const now = Date.now();
		const dt = Math.min(Math.max(now - last, 0), MAX_FRAME_MS);
		last = now;
		let settled = true;
		tracks.forEach((t, i) => {
			states[i] = stepSpring(states[i], t.target, dt, t);
			if (!isSpringSettled(states[i], t.target)) settled = false;
		});
		if (settled) {
			onFrame(tracks.map((t) => t.target));
			onDone?.();
			return;
		}
		onFrame(states.map((s) => s.position));
		raf = requestAnimationFrame(frame);
	};
	raf = requestAnimationFrame(frame);
	return () => cancelAnimationFrame(raf);
}
var zoomSettings = {
	scale: 1,
	zoom: true,
	infiniteZoom: true,
	actualSize: true,
	showZoomInOutIcons: false,
	actualSizeIcons: {
		zoomIn: "lg-zoom-in",
		zoomOut: "lg-zoom-out"
	},
	enableZoomAfter: 300
};
var lGEvents$2 = {
	containerResize: "lgContainerResize",
	beforeOpen: "lgBeforeOpen",
	afterOpen: "lgAfterOpen",
	slideItemLoad: "lgSlideItemLoad",
	afterSlide: "lgAfterSlide",
	rotateLeft: "lgRotateLeft",
	rotateRight: "lgRotateRight",
	flipHorizontal: "lgFlipHorizontal",
	flipVertical: "lgFlipVertical"
};
var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, {
	enumerable: true,
	configurable: true,
	writable: true,
	value
}) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
	for (var prop in b || (b = {})) if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
	if (__getOwnPropSymbols$4) {
		for (var prop of __getOwnPropSymbols$4(b)) if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
	}
	return a;
};
var ZOOM_TRANSITION_DURATION = 500;
var Zoom = class {
	constructor(instance, $LG) {
		this.core = instance;
		this.$LG = $LG;
		this.settings = __spreadValues$4(__spreadValues$4({}, zoomSettings), this.core.settings);
		return this;
	}
	buildTemplates() {
		var _a, _b, _c, _d, _e, _f;
		const gestureButtons = this.core.settings.showGestureButtons !== false;
		let zoomIcons = gestureButtons && this.settings.showZoomInOutIcons ? `<button id="${this.core.getIdName("lg-zoom-in")}" type="button" aria-label="${(_b = (_a = this.settings.zoomPluginStrings) == null ? void 0 : _a.zoomIn) != null ? _b : this.core.settings.strings.zoomIn}" class="lg-zoom-in lg-icon"></button><button id="${this.core.getIdName("lg-zoom-out")}" type="button" aria-label="${(_d = (_c = this.settings.zoomPluginStrings) == null ? void 0 : _c.zoomOut) != null ? _d : this.core.settings.strings.zoomOut}" class="lg-zoom-out lg-icon"></button>` : "";
		if (gestureButtons && this.settings.actualSize) zoomIcons += `<button id="${this.core.getIdName("lg-actual-size")}" type="button" aria-label="${(_f = (_e = this.settings.zoomPluginStrings) == null ? void 0 : _e.viewActualSize) != null ? _f : this.core.settings.strings.viewActualSize}" class="${this.settings.actualSizeIcons.zoomIn} lg-icon"></button>`;
		this.core.outer.addClass("lg-use-transition-for-zoom");
		this.core.$toolbar.first().append(zoomIcons);
	}
	/**
	* @desc Enable zoom option only once the image is completely loaded
	* If zoomFromOrigin is true, Zoom is enabled once the dummy image has been inserted
	*
	* Zoom styles are defined under lg-zoomable CSS class.
	*/
	enableZoom(event) {
		let _speed = this.settings.enableZoomAfter + event.detail.delay;
		if (this.$LG("body").first().hasClass("lg-from-hash") && event.detail.delay) _speed = 0;
		else this.$LG("body").first().removeClass("lg-from-hash");
		this.zoomableTimeout = setTimeout(() => {
			if (!this.isImageSlide(this.core.index)) return;
			this.core.getSlideItem(event.detail.index).addClass("lg-zoomable");
			if (event.detail.index === this.core.index) this.setZoomEssentials();
		}, _speed + 30);
	}
	enableZoomOnSlideItemLoad() {
		this.core.LGel.on(`${lGEvents$2.slideItemLoad}.zoom`, this.enableZoom.bind(this));
	}
	getDragCords(e) {
		return {
			x: e.pageX,
			y: e.pageY
		};
	}
	getSwipeCords(e) {
		return {
			x: e.touches[0].pageX,
			y: e.touches[0].pageY
		};
	}
	getDragAllowedAxises(scale, scaleDiff) {
		if (!this.containerRect) return {
			allowX: false,
			allowY: false
		};
		const $image = this.core.getSlideItem(this.core.index).find(".lg-image").first().get();
		let height = 0;
		let width = 0;
		const rect = $image.getBoundingClientRect();
		if (scale) {
			const visual = this.getVisualImageSize($image, $image.offsetWidth, $image.offsetHeight);
			height = visual.height * scale;
			width = visual.width * scale;
		} else if (scaleDiff) {
			height = rect.height + scaleDiff * rect.height;
			width = rect.width + scaleDiff * rect.width;
		} else if (this.core.currentImageSize) {
			const visual = this.getVisualImageSize($image, this.core.currentImageSize.width, this.core.currentImageSize.height);
			height = visual.height * this.scale;
			width = visual.width * this.scale;
		} else {
			height = rect.height;
			width = rect.width;
		}
		const allowY = height > this.containerRect.height;
		return {
			allowX: width > this.containerRect.width,
			allowY
		};
	}
	setZoomEssentials() {
		this.containerRect = this.core.$content.get().getBoundingClientRect();
	}
	/**
	* @desc Image zoom
	* Translate the wrap and scale the image to get better user experience
	*
	* @param {String} scale - Zoom decrement/increment value
	*/
	zoomImage(scale, scaleDiff, reposition, resetToMax) {
		if (!this.containerRect || Math.abs(scaleDiff) <= 0) return;
		const offsetX = this.containerRect.width / 2 + this.containerRect.left;
		const offsetY = this.containerRect.height / 2 + this.containerRect.top + this.scrollTop;
		let originalX;
		let originalY;
		if (scale === 1) this.positionChanged = false;
		if (this.positionChanged) {
			const previousScale = this.scale - scaleDiff;
			originalX = previousScale ? this.left / previousScale : 0;
			originalY = previousScale ? this.top / previousScale : 0;
			this.pageX = offsetX - originalX;
			this.pageY = offsetY - originalY;
			this.positionChanged = false;
		}
		let x;
		let y;
		let _x = offsetX - this.pageX;
		let _y = offsetY - this.pageY;
		if (scale - scaleDiff > 1) {
			const scaleVal = (scale - scaleDiff) / Math.abs(scaleDiff);
			_x = (scaleDiff < 0 ? -_x : _x) + this.left * (scaleVal + (scaleDiff < 0 ? -1 : 1));
			_y = (scaleDiff < 0 ? -_y : _y) + this.top * (scaleVal + (scaleDiff < 0 ? -1 : 1));
			x = _x / scaleVal;
			y = _y / scaleVal;
		} else {
			const scaleVal = (scale - scaleDiff) * scaleDiff;
			x = _x * scaleVal;
			y = _y * scaleVal;
		}
		if (reposition) {
			const clamped = this.clampPinchPan({
				x,
				y
			}, scale);
			x = clamped.x;
			y = clamped.y;
		}
		this.setZoomStyles({
			x,
			y,
			scale
		});
		this.left = x;
		this.top = y;
		if (resetToMax) this.setZoomImageSize();
	}
	resetImageTranslate(index) {
		if (!this.isImageSlide(index)) return;
		const $image = this.core.getSlideItem(index).find(".lg-image").first();
		this.imageReset = false;
		$image.removeClass("reset-transition reset-transition-y reset-transition-x");
		this.core.outer.removeClass("lg-actual-size");
		$image.css("width", "auto").css("height", "auto");
		setTimeout(() => {
			$image.removeClass("no-transition");
		}, 10);
	}
	setZoomImageSize(delay = ZOOM_TRANSITION_DURATION) {
		const $image = this.core.getSlideItem(this.core.index).find(".lg-image").first();
		setTimeout(() => {
			if (this.core.touchAction) return;
			const actualSizeScale = this.getCurrentImageActualSizeScale();
			if (this.scale >= actualSizeScale) {
				$image.addClass("no-transition");
				this.imageReset = true;
			}
		}, delay);
		setTimeout(() => {
			if (this.core.touchAction) return;
			const actualSizeScale = this.getCurrentImageActualSizeScale();
			if (this.scale >= actualSizeScale) {
				const dragAllowedAxises = this.getDragAllowedAxises(this.scale);
				const image = $image.get();
				const referenceWidth = this.getNaturalWidth(this.core.index);
				const referenceHeight = image.naturalWidth > 0 ? referenceWidth * image.naturalHeight / image.naturalWidth : image.naturalHeight;
				$image.css("width", referenceWidth + "px").css("height", referenceHeight + "px");
				this.core.outer.addClass("lg-actual-size");
				if (dragAllowedAxises.allowX && dragAllowedAxises.allowY) $image.addClass("reset-transition");
				else if (dragAllowedAxises.allowX && !dragAllowedAxises.allowY) $image.addClass("reset-transition-x");
				else if (!dragAllowedAxises.allowX && dragAllowedAxises.allowY) $image.addClass("reset-transition-y");
			}
		}, delay + 50);
	}
	/**
	* @desc apply scale3d to image and translate to image wrap
	* @param {style} X,Y and scale
	*/
	setZoomStyles(style) {
		const $imageWrap = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first();
		const $image = this.core.getSlideItem(this.core.index).find(".lg-image").first();
		const $dummyImage = this.core.outer.find(".lg-current .lg-dummy-img").first();
		this.scale = style.scale;
		$image.css("transform", "scale3d(" + style.scale + ", " + style.scale + ", 1)");
		$dummyImage.css("transform", "scale3d(" + style.scale + ", " + style.scale + ", 1)");
		const transform = "translate3d(" + style.x + "px, " + style.y + "px, 0)";
		$imageWrap.css("transform", transform);
	}
	/**
	* @param index - Index of the current slide
	* @param event - event will be available only if the function is called on clicking/taping the imags
	*/
	setActualSize(index, event) {
		if (this.zoomInProgress) return;
		this.zoomInProgress = true;
		const currentItem = this.core.galleryItems[this.core.index];
		this.resetImageTranslate(index);
		setTimeout(() => {
			if (!currentItem.src || this.core.outer.hasClass("lg-first-slide-loading")) return;
			const scale = this.getCurrentImageActualSizeScale();
			const prevScale = this.scale;
			if (this.core.outer.hasClass("lg-zoomed")) this.scale = 1;
			else this.scale = this.getScale(scale);
			this.setPageCords(event);
			this.beginZoom(this.scale);
			this.zoomImage(this.scale, this.scale - prevScale, true, true);
		}, 50);
		setTimeout(() => {
			this.core.outer.removeClass("lg-grabbing").addClass("lg-grab");
		}, 60);
		setTimeout(() => {
			this.zoomInProgress = false;
		}, 610);
	}
	getNaturalWidth(index) {
		const $image = this.core.getSlideItem(index).find(".lg-image").first();
		return getActualSizeWidth(this.core.galleryItems[index], { width: window.innerWidth }, $image.get().naturalWidth);
	}
	getActualSizeScale(naturalWidth, width) {
		let scale;
		if (naturalWidth >= width) scale = getActualSizeScale(naturalWidth, width);
		else scale = 1;
		return scale;
	}
	getCurrentImageActualSizeScale() {
		var _a;
		const image = this.core.getSlideItem(this.core.index).find(".lg-image").first().get();
		let width = (_a = this.core.currentImageSize) == null ? void 0 : _a.width;
		if (!width) {
			if (this.core.outer.hasClass("lg-actual-size")) {
				if (!this.containerRect) this.setZoomEssentials();
				const referenceWidth = this.getNaturalWidth(this.core.index);
				width = fitImageSize({
					width: referenceWidth,
					height: image.naturalWidth > 0 ? referenceWidth * image.naturalHeight / image.naturalWidth : image.naturalHeight
				}, this.containerRect.width, this.containerRect.height).width;
			} else width = image.offsetWidth;
		}
		const naturalWidth = this.getNaturalWidth(this.core.index) || width;
		return this.getActualSizeScale(naturalWidth, width);
	}
	getPageCords(event) {
		const cords = {};
		if (event) {
			cords.x = event.pageX || event.touches[0].pageX;
			cords.y = event.pageY || event.touches[0].pageY;
		} else {
			const containerRect = this.core.$content.get().getBoundingClientRect();
			cords.x = containerRect.width / 2 + containerRect.left;
			cords.y = containerRect.height / 2 + this.scrollTop + containerRect.top;
		}
		return cords;
	}
	setPageCords(event) {
		const pageCords = this.getPageCords(event);
		this.pageX = pageCords.x;
		this.pageY = pageCords.y;
	}
	manageActualPixelClassNames() {
		this.core.getElementById("lg-actual-size").removeClass(this.settings.actualSizeIcons.zoomIn).addClass(this.settings.actualSizeIcons.zoomOut);
	}
	beginZoom(scale) {
		this.core.outer.removeClass("lg-zoom-drag-transition lg-zoom-dragging");
		if (scale > 1) {
			this.core.outer.addClass("lg-zoomed");
			this.manageActualPixelClassNames();
		} else this.resetZoom();
		return scale > 1;
	}
	getScale(scale) {
		const actualSizeScale = this.getCurrentImageActualSizeScale();
		if (scale < 1) scale = 1;
		else if (scale > actualSizeScale) scale = actualSizeScale;
		return scale;
	}
	init() {
		this.core.registerDefaultIcons(zoomDefaultIcons);
		if (!this.settings.zoom) return;
		this.buildTemplates();
		this.enableZoomOnSlideItemLoad();
		let tapped = null;
		this.core.outer.on("dblclick.lg", (event) => {
			if (!this.$LG(event.target).hasClass("lg-image")) return;
			this.setActualSize(this.core.index, event);
		});
		this.core.outer.on("touchstart.lg", (event) => {
			const $target = this.$LG(event.target);
			if (event.touches.length === 1 && $target.hasClass("lg-image")) {
				if (!tapped) tapped = setTimeout(() => {
					tapped = null;
				}, 300);
				else {
					clearTimeout(tapped);
					tapped = null;
					event.preventDefault();
					this.setActualSize(this.core.index, event);
				}
			}
		});
		this.core.LGel.on(`${lGEvents$2.containerResize}.zoom ${lGEvents$2.rotateRight}.zoom ${lGEvents$2.rotateLeft}.zoom ${lGEvents$2.flipHorizontal}.zoom ${lGEvents$2.flipVertical}.zoom`, () => {
			if (!this.core.lgOpened || !this.isImageSlide(this.core.index) || this.core.touchAction) return;
			this.stopZoomSpring();
			const _LGel = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first();
			this.top = 0;
			this.left = 0;
			this.setZoomEssentials();
			this.setZoomSwipeStyles(_LGel, {
				x: 0,
				y: 0
			});
			this.positionChanged = true;
		});
		this.$LG(window).on(`scroll.lg.zoom.global${this.core.lgId}`, () => {
			if (!this.core.lgOpened) return;
			this.scrollTop = this.$LG(window).scrollTop();
		});
		this.core.getElementById("lg-zoom-out").on("click.lg", () => {
			if (!this.isImageSlide(this.core.index)) return;
			let timeout = 0;
			if (this.imageReset) {
				this.resetImageTranslate(this.core.index);
				timeout = 50;
			}
			setTimeout(() => {
				let scale = this.scale - this.settings.scale;
				if (scale < 1) scale = 1;
				this.beginZoom(scale);
				this.zoomImage(scale, -this.settings.scale, true, !this.settings.infiniteZoom);
			}, timeout);
		});
		this.core.getElementById("lg-zoom-in").on("click.lg", () => {
			this.zoomIn();
		});
		this.core.getElementById("lg-actual-size").on("click.lg", () => {
			this.setActualSize(this.core.index);
		});
		this.core.LGel.on(`${lGEvents$2.beforeOpen}.zoom`, () => {
			this.core.outer.find(".lg-item").removeClass("lg-zoomable");
		});
		this.core.LGel.on(`${lGEvents$2.afterOpen}.zoom`, () => {
			this.scrollTop = this.$LG(window).scrollTop();
			this.pageX = this.core.outer.width() / 2;
			this.pageY = this.core.outer.height() / 2 + this.scrollTop;
			this.scale = 1;
		});
		this.core.LGel.on(`${lGEvents$2.afterSlide}.zoom`, (event) => {
			const { prevIndex } = event.detail;
			this.scale = 1;
			this.positionChanged = false;
			this.zoomInProgress = false;
			this.resetZoom(prevIndex);
			this.resetImageTranslate(prevIndex);
			if (this.isImageSlide(this.core.index)) this.setZoomEssentials();
		});
		this.zoomDrag();
		this.pinchZoom();
		this.zoomSwipe();
		this.zoomableTimeout = false;
		this.positionChanged = false;
		this.zoomInProgress = false;
	}
	zoomIn() {
		if (!this.isImageSlide(this.core.index)) return;
		let scale = this.scale + this.settings.scale;
		if (!this.settings.infiniteZoom) scale = this.getScale(scale);
		this.beginZoom(scale);
		this.zoomImage(scale, Math.min(this.settings.scale, scale - this.scale), true, !this.settings.infiniteZoom);
	}
	resetZoom(index) {
		this.stopZoomSpring();
		this.core.outer.removeClass("lg-zoomed lg-zoom-drag-transition");
		const $actualSize = this.core.getElementById("lg-actual-size");
		const $item = this.core.getSlideItem(index !== void 0 ? index : this.core.index);
		$actualSize.removeClass(this.settings.actualSizeIcons.zoomOut).addClass(this.settings.actualSizeIcons.zoomIn);
		$item.find(".lg-img-wrap").first().removeAttr("style");
		$item.find(".lg-image").first().removeAttr("style");
		this.scale = 1;
		this.left = 0;
		this.top = 0;
		this.setPageCords();
	}
	/** Stop a running release spring; state stays at its live values. */
	stopZoomSpring() {
		if (this.cancelZoomSpring) {
			this.cancelZoomSpring();
			this.cancelZoomSpring = void 0;
		}
	}
	/**
	* Any gesture end must leave the image inside its pan bounds: a tap
	* interrupts a settling spring (stopZoomSpring at its touchstart),
	* and if it never turns into a drag nothing else re-clamps, the
	* fused pinch pan can legitimately be far outside mid-settle.
	* Springs home from wherever the interruption stopped it; a no-op
	* when already in bounds (the common tap).
	*/
	settleIntoBounds() {
		this.setZoomEssentials();
		const rect = this.core.getSlideItem(this.core.index).find(".lg-image").first().get().getBoundingClientRect();
		const actualSizeScale = this.getCurrentImageActualSizeScale();
		const targetScale = this.settings.infiniteZoom ? Math.max(this.scale, 1) : Math.min(Math.max(this.scale, 1), Math.max(actualSizeScale, 1));
		const sizeRatio = this.scale > 0 ? targetScale / this.scale : 1;
		const width = rect.width * sizeRatio;
		const height = rect.height * sizeRatio;
		const { bottom } = this.core.mediaContainerPosition;
		const halfX = Math.abs(width - this.containerRect.width) / 2;
		const halfY = Math.abs(height - this.containerRect.height) / 2;
		const floorY = height > this.containerRect.height ? Math.min(-halfY + bottom, halfY) : -halfY;
		const targetX = Math.min(Math.max(this.left, -halfX), halfX);
		const targetY = Math.min(Math.max(this.top, floorY), halfY);
		if (Math.abs(targetX - this.left) < 1 && Math.abs(targetY - this.top) < 1 && Math.abs(targetScale - this.scale) < .001) return;
		this.core.outer.addClass("lg-zoom-drag-transition lg-zoom-dragging");
		this.stopZoomSpring();
		this.cancelZoomSpring = runSprings([
			{
				from: this.scale,
				velocity: 0,
				target: targetScale
			},
			{
				from: this.left,
				velocity: 0,
				target: targetX
			},
			{
				from: this.top,
				velocity: 0,
				target: targetY
			}
		], ([scale, x, y]) => {
			this.left = x;
			this.top = y;
			this.setZoomStyles({
				x,
				y,
				scale
			});
		}, () => {
			this.cancelZoomSpring = void 0;
			this.core.outer.removeClass("lg-zoom-dragging lg-zoom-drag-transition");
			if (targetScale > 1 && targetScale >= Math.max(actualSizeScale, 1)) this.setZoomImageSize(0);
		});
	}
	getTouchDistance(e) {
		return getPointerDistance({
			x: e.touches[0].pageX,
			y: e.touches[0].pageY
		}, {
			x: e.touches[1].pageX,
			y: e.touches[1].pageY
		});
	}
	/**
	* Pinch midpoint relative to the stage centre, the focal anchor the
	* whole gesture projects through.
	*/
	getPinchMidPoint(e) {
		const centerX = this.containerRect.width / 2 + this.containerRect.left;
		const centerY = this.containerRect.height / 2 + this.containerRect.top + this.scrollTop;
		return {
			x: (e.touches[0].pageX + e.touches[1].pageX) / 2 - centerX,
			y: (e.touches[0].pageY + e.touches[1].pageY) / 2 - centerY
		};
	}
	/**
	* Clamp a pan into the stage-aware bounds at the given scale,
	* measured from the untransformed layout size (offset dimensions
	* ignore transforms, so this stays correct mid-gesture). Y matches
	* `getPossibleSwipeDragCords`: the vacated components strip belongs
	* to the stage, so the pan-up floor sits where the image's bottom
	* edge meets the SCREEN bottom, not the content box.
	*/
	/**
	* Bounds-relevant size of the image: layout offsets swapped and
	* shrunk by the rotate plugin's wrapper transform when present,
	* at 90°/270° the visual width runs along the layout height, and
	* offsets don't see transforms.
	*/
	getVisualImageSize($image, width, height) {
		const rotateWrap = $image.closest(".lg-img-rotate");
		return getRotatedVisualSize(width, height, rotateWrap == null ? void 0 : rotateWrap.style.transform);
	}
	clampPinchPan(pan, scale) {
		const $image = this.core.getSlideItem(this.core.index).find(".lg-image").first().get();
		const visual = this.getVisualImageSize($image, $image.offsetWidth, $image.offsetHeight);
		return clampPanToStage(pan, getPanBounds(visual.width, visual.height, this.containerRect.width, this.containerRect.height, scale), this.core.mediaContainerPosition.bottom);
	}
	pinchZoom() {
		let startDist = 0;
		let pinchStarted = false;
		let initScale = 1;
		let startMaxScale = 1;
		let startPan = {
			x: 0,
			y: 0
		};
		let startMid = {
			x: 0,
			y: 0
		};
		let maxGestureScale = 1;
		let lastMid = {
			x: 0,
			y: 0
		};
		let midSamples = [];
		let $item = this.core.getSlideItem(this.core.index);
		this.core.outer.on("touchstart.lg", (e) => {
			$item = this.core.getSlideItem(this.core.index);
			if (!this.isImageSlide(this.core.index)) return;
			if (e.touches.length === 2) {
				e.preventDefault();
				if (this.core.outer.hasClass("lg-first-slide-loading")) return;
				this.stopZoomSpring();
				this.setZoomEssentials();
				initScale = this.scale || 1;
				startPan = {
					x: this.left,
					y: this.top
				};
				startMid = this.getPinchMidPoint(e);
				this.core.outer.addClass("lg-zoom-drag-transition lg-zoom-dragging");
				this.setPageCords(e);
				this.resetImageTranslate(this.core.index);
				startMaxScale = this.getCurrentImageActualSizeScale();
				this.core.touchAction = "pinch";
				startDist = this.getTouchDistance(e);
				maxGestureScale = initScale;
				lastMid = startMid;
				midSamples = [{
					x: startMid.x,
					y: startMid.y,
					t: Date.now()
				}];
			}
		});
		this.core.$inner.on("touchmove.lg", (e) => {
			if (e.touches.length === 2 && this.core.touchAction === "pinch" && (this.$LG(e.target).hasClass("lg-item") || $item.get().contains(e.target))) {
				e.preventDefault();
				const endDist = this.getTouchDistance(e);
				const distance = startDist - endDist;
				if (!pinchStarted && Math.abs(distance) > 5) pinchStarted = true;
				if (pinchStarted) {
					const closeArmed = this.core.settings.pinchToClose && this.core.settings.closable && maxGestureScale <= 1;
					const _scale = getPinchScale(startDist, endDist, initScale, startMaxScale, this.settings.infiniteZoom, closeArmed);
					const scale = Math.round((_scale + Number.EPSILON) * 1e4) / 1e4;
					const mid = this.getPinchMidPoint(e);
					lastMid = mid;
					midSamples = pushVelocitySample(midSamples, {
						x: mid.x,
						y: mid.y,
						t: Date.now()
					});
					const pan = getPinchPan(mid, startMid, startPan, initScale, scale);
					this.left = pan.x;
					this.top = pan.y;
					this.setZoomStyles({
						x: pan.x,
						y: pan.y,
						scale
					});
					maxGestureScale = Math.max(maxGestureScale, scale);
				}
			}
		});
		this.core.$inner.on("touchend.lg", (e) => {
			if (this.core.touchAction === "pinch" && (this.$LG(e.target).hasClass("lg-item") || $item.get().contains(e.target))) {
				pinchStarted = false;
				startDist = 0;
				if (shouldCloseOnPinch({
					scale: this.scale,
					maxGestureScale,
					pinchToClose: this.core.settings.pinchToClose,
					closable: this.core.settings.closable
				})) {
					this.core.outer.removeClass("lg-zoom-dragging");
					this.resetZoom();
					this.core.closeGallery();
				} else if (this.scale <= 1) {
					this.core.outer.removeClass("lg-zoomed");
					this.stopZoomSpring();
					this.cancelZoomSpring = runSprings([
						{
							from: this.scale,
							velocity: 0,
							target: 1
						},
						{
							from: this.left,
							velocity: 0,
							target: 0
						},
						{
							from: this.top,
							velocity: 0,
							target: 0
						}
					], ([scale, x, y]) => {
						this.left = x;
						this.top = y;
						this.setZoomStyles({
							x,
							y,
							scale
						});
					}, () => {
						this.cancelZoomSpring = void 0;
						this.core.outer.removeClass("lg-zoom-dragging");
						this.resetZoom();
					});
				} else {
					const actualSizeScale = startMaxScale;
					const targetScale = Math.min(this.scale, Math.max(actualSizeScale, 1));
					const midVelocity = getWindowedVelocity(midSamples, Date.now());
					const basePan = getPinchPan(lastMid, startMid, startPan, initScale, targetScale);
					const glide = {
						x: basePan.x + project(midVelocity.x),
						y: basePan.y + project(midVelocity.y)
					};
					const pan = this.clampPinchPan(glide, targetScale);
					this.positionChanged = true;
					this.manageActualPixelClassNames();
					this.core.outer.addClass("lg-zoomed");
					this.stopZoomSpring();
					this.cancelZoomSpring = runSprings([
						{
							from: this.scale,
							velocity: 0,
							target: targetScale
						},
						{
							from: this.left,
							velocity: midVelocity.x,
							target: pan.x,
							dampingRatio: pan.x !== glide.x ? SPRING_BOUNCE_DAMPING : 1
						},
						{
							from: this.top,
							velocity: midVelocity.y,
							target: pan.y,
							dampingRatio: pan.y !== glide.y ? SPRING_BOUNCE_DAMPING : 1
						}
					], ([scale, x, y]) => {
						this.left = x;
						this.top = y;
						this.setZoomStyles({
							x,
							y,
							scale
						});
					}, () => {
						this.cancelZoomSpring = void 0;
						this.core.outer.removeClass("lg-zoom-dragging lg-zoom-drag-transition");
						if (targetScale >= actualSizeScale) this.setZoomImageSize(0);
					});
				}
				this.core.touchAction = void 0;
			}
		});
	}
	touchendZoom(startCoords, endCoords, allowX, allowY, velocity) {
		const _LGel = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first();
		const possibleSwipeCords = this.getPossibleSwipeDragCords();
		const current = this.getZoomSwipeCords(startCoords, endCoords, allowX, allowY, possibleSwipeCords);
		const clampAxis = (value, min, max) => Math.min(Math.max(value, max), min);
		const targetX = allowX ? clampAxis(current.x + project(velocity.x), possibleSwipeCords.minX, possibleSwipeCords.maxX) : this.left;
		const targetY = allowY ? clampAxis(current.y + project(velocity.y), possibleSwipeCords.minY, possibleSwipeCords.maxY) : this.top;
		this.positionChanged = true;
		if (Math.abs(targetX - current.x) < 1 && Math.abs(targetY - current.y) < 1) {
			this.left = targetX;
			this.top = targetY;
			this.setZoomSwipeStyles(_LGel, {
				x: targetX,
				y: targetY
			});
			this.core.outer.removeClass("lg-zoom-dragging lg-zoom-drag-transition");
			return;
		}
		this.core.outer.addClass("lg-zoom-dragging");
		this.stopZoomSpring();
		this.cancelZoomSpring = runSprings([{
			from: current.x,
			velocity: velocity.x,
			target: targetX,
			dampingRatio: targetX !== current.x + project(velocity.x) ? SPRING_BOUNCE_DAMPING : 1
		}, {
			from: current.y,
			velocity: velocity.y,
			target: targetY,
			dampingRatio: targetY !== current.y + project(velocity.y) ? SPRING_BOUNCE_DAMPING : 1
		}], ([x, y]) => {
			this.left = x;
			this.top = y;
			this.setZoomSwipeStyles(_LGel, {
				x,
				y
			});
		}, () => {
			this.cancelZoomSpring = void 0;
			this.core.outer.removeClass("lg-zoom-dragging lg-zoom-drag-transition");
		});
	}
	getZoomSwipeCords(startCoords, endCoords, allowX, allowY, possibleSwipeCords) {
		const distance = {};
		if (allowY) {
			distance.y = this.top + (endCoords.y - startCoords.y);
			if (this.isBeyondPossibleTop(distance.y, possibleSwipeCords.minY)) {
				const diffMinY = possibleSwipeCords.minY - distance.y;
				distance.y = possibleSwipeCords.minY - diffMinY / 6;
			} else if (this.isBeyondPossibleBottom(distance.y, possibleSwipeCords.maxY)) {
				const diffMaxY = distance.y - possibleSwipeCords.maxY;
				distance.y = possibleSwipeCords.maxY + diffMaxY / 6;
			}
		} else distance.y = this.top;
		if (allowX) {
			distance.x = this.left + (endCoords.x - startCoords.x);
			if (this.isBeyondPossibleLeft(distance.x, possibleSwipeCords.minX)) {
				const diffMinX = possibleSwipeCords.minX - distance.x;
				distance.x = possibleSwipeCords.minX - diffMinX / 6;
			} else if (this.isBeyondPossibleRight(distance.x, possibleSwipeCords.maxX)) {
				const difMaxX = distance.x - possibleSwipeCords.maxX;
				distance.x = possibleSwipeCords.maxX + difMaxX / 6;
			}
		} else distance.x = this.left;
		return distance;
	}
	isBeyondPossibleLeft(x, minX) {
		return x >= minX;
	}
	isBeyondPossibleRight(x, maxX) {
		return x <= maxX;
	}
	isBeyondPossibleTop(y, minY) {
		return y >= minY;
	}
	isBeyondPossibleBottom(y, maxY) {
		return y <= maxY;
	}
	isImageSlide(index) {
		const currentItem = this.core.galleryItems[index];
		return this.core.getSlideType(currentItem) === "image";
	}
	getPossibleSwipeDragCords(scale) {
		const imgRect = this.core.getSlideItem(this.core.index).find(".lg-image").first().get().getBoundingClientRect();
		let imageHeight = imgRect.height;
		let imageWidth = imgRect.width;
		if (scale) {
			imageHeight = imageHeight + scale * imageHeight;
			imageWidth = imageWidth + scale * imageWidth;
		}
		const { bottom } = this.core.mediaContainerPosition;
		return {
			minY: (imageHeight - this.containerRect.height) / 2,
			maxY: (this.containerRect.height - imageHeight) / 2 + bottom,
			minX: (imageWidth - this.containerRect.width) / 2,
			maxX: (this.containerRect.width - imageWidth) / 2
		};
	}
	setZoomSwipeStyles(LGel, distance) {
		LGel.css("transform", "translate3d(" + distance.x + "px, " + distance.y + "px, 0)");
	}
	zoomSwipe() {
		let startCoords = {};
		let endCoords = {};
		let isMoved = false;
		let allowX = false;
		let allowY = false;
		let samples = [];
		let possibleSwipeCords;
		let _LGel;
		let $item = this.core.getSlideItem(this.core.index);
		this.core.$inner.on("touchstart.lg", (e) => {
			if (!this.isImageSlide(this.core.index)) return;
			$item = this.core.getSlideItem(this.core.index);
			if ((this.$LG(e.target).hasClass("lg-item") || $item.get().contains(e.target)) && e.touches.length === 1 && this.core.outer.hasClass("lg-zoomed")) {
				e.preventDefault();
				this.stopZoomSpring();
				isMoved = false;
				endCoords = {};
				const startPoint = this.getSwipeCords(e);
				samples = [{
					x: startPoint.x,
					y: startPoint.y,
					t: Date.now()
				}];
				this.core.touchAction = "zoomSwipe";
				_LGel = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first();
				const dragAllowedAxises = this.getDragAllowedAxises(0);
				allowY = dragAllowedAxises.allowY;
				allowX = dragAllowedAxises.allowX;
				startCoords = this.getSwipeCords(e);
				possibleSwipeCords = this.getPossibleSwipeDragCords();
				this.core.outer.addClass("lg-zoom-dragging lg-zoom-drag-transition");
			}
		});
		this.core.$inner.on("touchmove.lg", (e) => {
			if (e.touches.length === 1 && this.core.touchAction === "zoomSwipe" && (this.$LG(e.target).hasClass("lg-item") || $item.get().contains(e.target))) {
				e.preventDefault();
				this.core.touchAction = "zoomSwipe";
				endCoords = this.getSwipeCords(e);
				samples = pushVelocitySample(samples, {
					x: endCoords.x,
					y: endCoords.y,
					t: Date.now()
				});
				const distance = this.getZoomSwipeCords(startCoords, endCoords, allowX, allowY, possibleSwipeCords);
				if (Math.abs(endCoords.x - startCoords.x) > 15 || Math.abs(endCoords.y - startCoords.y) > 15) {
					isMoved = true;
					this.setZoomSwipeStyles(_LGel, distance);
				}
			}
		});
		this.core.$inner.on("touchend.lg", (e) => {
			if (this.core.touchAction === "zoomSwipe" && (this.$LG(e.target).hasClass("lg-item") || $item.get().contains(e.target))) {
				e.preventDefault();
				this.core.touchAction = void 0;
				this.core.outer.removeClass("lg-zoom-dragging");
				if (!isMoved) {
					this.settleIntoBounds();
					return;
				}
				isMoved = false;
				this.touchendZoom(startCoords, endCoords, allowX, allowY, getWindowedVelocity(samples, Date.now()));
			}
		});
	}
	zoomDrag() {
		let startCoords = {};
		let endCoords = {};
		let isDragging = false;
		let isMoved = false;
		let allowX = false;
		let allowY = false;
		let dragSamples = [];
		let possibleSwipeCords;
		let _LGel;
		this.core.outer.on("mousedown.lg.zoom", (e) => {
			if (!this.isImageSlide(this.core.index)) return;
			const $item = this.core.getSlideItem(this.core.index);
			if (this.$LG(e.target).hasClass("lg-item") || $item.get().contains(e.target)) {
				if (this.core.outer.hasClass("lg-zoomed")) this.stopZoomSpring();
				dragSamples = [{
					x: e.pageX,
					y: e.pageY,
					t: Date.now()
				}];
				_LGel = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first();
				const dragAllowedAxises = this.getDragAllowedAxises(0);
				allowY = dragAllowedAxises.allowY;
				allowX = dragAllowedAxises.allowX;
				if (this.core.outer.hasClass("lg-zoomed")) {
					if (this.$LG(e.target).hasClass("lg-object") && (allowX || allowY)) {
						e.preventDefault();
						startCoords = this.getDragCords(e);
						possibleSwipeCords = this.getPossibleSwipeDragCords();
						isDragging = true;
						this.core.outer.removeClass("lg-grab").addClass("lg-grabbing lg-zoom-drag-transition lg-zoom-dragging");
					}
				}
			}
		});
		this.$LG(window).on(`mousemove.lg.zoom.global${this.core.lgId}`, (e) => {
			if (isDragging) {
				isMoved = true;
				endCoords = this.getDragCords(e);
				dragSamples = pushVelocitySample(dragSamples, {
					x: endCoords.x,
					y: endCoords.y,
					t: Date.now()
				});
				const distance = this.getZoomSwipeCords(startCoords, endCoords, allowX, allowY, possibleSwipeCords);
				this.setZoomSwipeStyles(_LGel, distance);
			}
		});
		this.$LG(window).on(`mouseup.lg.zoom.global${this.core.lgId}`, (e) => {
			if (isDragging) {
				isDragging = false;
				this.core.outer.removeClass("lg-zoom-dragging");
				if (isMoved && (startCoords.x !== endCoords.x || startCoords.y !== endCoords.y)) {
					endCoords = this.getDragCords(e);
					this.touchendZoom(startCoords, endCoords, allowX, allowY, getWindowedVelocity(dragSamples, Date.now()));
				} else this.settleIntoBounds();
				isMoved = false;
			}
			this.core.outer.removeClass("lg-grabbing").addClass("lg-grab");
		});
	}
	closeGallery() {
		if (this.imageReset) this.resetImageTranslate(this.core.index);
		this.resetZoom();
		this.zoomInProgress = false;
	}
	destroy() {
		this.$LG(window).off(`.lg.zoom.global${this.core.lgId}`);
		this.core.LGel.off(".lg.zoom");
		this.core.LGel.off(".zoom");
		clearTimeout(this.zoomableTimeout);
		this.zoomableTimeout = false;
	}
};
//#endregion
//#region ../../../../../node_modules/lightgallery/plugins/hash/lg-hash.es5.js
/*!
* lightgallery | 3.0.0 | October 9th 2026
* http://www.lightgalleryjs.com/
* Copyright (c) 2020 Sachin Neravath;
* @license GPLv3
*/
function createHistoryHashDriver(win) {
	return {
		kind: "history",
		getHash: () => win.location.hash || "",
		replaceHash: (hash) => win.history.replaceState(null, "", win.location.pathname + win.location.search + hash),
		clearHash: () => win.history.replaceState(null, "", win.location.pathname + win.location.search),
		subscribe: (onChange) => {
			win.addEventListener("hashchange", onChange);
			return () => win.removeEventListener("hashchange", onChange);
		}
	};
}
function settleNavigateResult(result) {
	var _a, _b, _c, _d;
	const promises = result;
	(_b = (_a = promises == null ? void 0 : promises.committed) == null ? void 0 : _a.catch) == null || _b.call(_a, () => void 0);
	(_d = (_c = promises == null ? void 0 : promises.finished) == null ? void 0 : _c.catch) == null || _d.call(_c, () => void 0);
}
function createNavigationHashDriver(win, navigation) {
	const getHash = () => {
		var _a;
		const url = (_a = navigation.currentEntry) == null ? void 0 : _a.url;
		if (typeof url === "string") {
			const index = url.indexOf("#");
			return index === -1 ? "" : url.slice(index);
		}
		return win.location.hash || "";
	};
	return {
		kind: "navigation",
		getHash,
		replaceHash: (hash) => settleNavigateResult(navigation.navigate(win.location.pathname + win.location.search + hash, {
			history: "replace",
			state: { lgHash: hash }
		})),
		clearHash: () => win.history.replaceState(null, "", win.location.pathname + win.location.search),
		subscribe: (onChange) => {
			navigation.addEventListener("currententrychange", onChange);
			return () => navigation.removeEventListener("currententrychange", onChange);
		}
	};
}
function createHashDriver(win, preference = "auto") {
	const navigation = win.navigation;
	const navigationCapable = !!navigation && typeof navigation.navigate === "function" && typeof navigation.addEventListener === "function" && typeof navigation.removeEventListener === "function";
	if (preference !== "history" && navigationCapable) return createNavigationHashDriver(win, navigation);
	return createHistoryHashDriver(win);
}
var lGEvents$1 = {
	afterSlide: "lgAfterSlide",
	afterClose: "lgAfterClose"
};
var hashSettings = {
	hash: true,
	hashDriver: "auto",
	galleryId: "1",
	customSlideName: false
};
var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, {
	enumerable: true,
	configurable: true,
	writable: true,
	value
}) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
	for (var prop in b || (b = {})) if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
	if (__getOwnPropSymbols$3) {
		for (var prop of __getOwnPropSymbols$3(b)) if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
	}
	return a;
};
var Hash = class {
	constructor(instance, $LG) {
		this.core = instance;
		this.$LG = $LG;
		this.settings = __spreadValues$3(__spreadValues$3({}, hashSettings), this.core.settings);
		return this;
	}
	init() {
		if (!this.settings.hash) return;
		this.driver = createHashDriver(window, this.settings.hashDriver);
		this.oldHash = this.driver.getHash();
		setTimeout(() => {
			this.buildFromHash();
		}, 100);
		this.core.LGel.on(`${lGEvents$1.afterSlide}.hash`, this.onAfterSlide.bind(this));
		this.core.LGel.on(`${lGEvents$1.afterClose}.hash`, this.onCloseAfter.bind(this));
		this.unsubscribeDriver = this.driver.subscribe(this.onHashchange.bind(this));
	}
	onAfterSlide(event) {
		let slideName = this.core.galleryItems[event.detail.index].slideName;
		slideName = this.settings.customSlideName ? slideName || event.detail.index : event.detail.index;
		this.driver.replaceHash("#lg=" + this.settings.galleryId + "&slide=" + slideName);
	}
	/**
	* Get index of the slide from custom slideName. Has to be a public method. Used in hash plugin
	* @param {String} hash
	* @returns {Number} Index of the slide.
	*/
	getIndexFromUrl(hash = this.driver.getHash()) {
		const slideName = hash.split("&slide=")[1];
		let _idx = 0;
		if (this.settings.customSlideName) {
			for (let index = 0; index < this.core.galleryItems.length; index++) if (this.core.galleryItems[index].slideName === slideName) {
				_idx = index;
				break;
			}
		} else _idx = parseInt(slideName, 10);
		return isNaN(_idx) ? 0 : _idx;
	}
	buildFromHash() {
		const _hash = this.driver.getHash();
		if (_hash.indexOf("lg=" + this.settings.galleryId) > 0) {
			this.$LG(document.body).addClass("lg-from-hash");
			const index = this.getIndexFromUrl(_hash);
			this.core.openGallery(index);
			return true;
		}
	}
	onCloseAfter() {
		if (this.oldHash && this.oldHash.indexOf("lg=" + this.settings.galleryId) < 0) this.driver.replaceHash(this.oldHash);
		else this.driver.clearHash();
	}
	onHashchange() {
		if (!this.core.lgOpened) return;
		const _hash = this.driver.getHash();
		const index = this.getIndexFromUrl(_hash);
		if (_hash.indexOf("lg=" + this.settings.galleryId) > -1) this.core.slide(index, false, false);
		else if (this.core.lGalleryOn) this.core.closeGallery();
	}
	closeGallery() {
		if (this.settings.hash) this.$LG(document.body).removeClass("lg-from-hash");
	}
	destroy() {
		var _a;
		this.core.LGel.off(".lg.hash");
		this.core.LGel.off(".hash");
		(_a = this.unsubscribeDriver) == null || _a.call(this);
		this.unsubscribeDriver = void 0;
	}
};
//#endregion
//#region ../../../../../node_modules/lightgallery/plugins/fullscreen/lg-fullscreen.es5.js
/*!
* lightgallery | 3.0.0 | October 9th 2026
* http://www.lightgalleryjs.com/
* Copyright (c) 2020 Sachin Neravath;
* @license GPLv3
*/
var fullscreenDefaultIcons = {
	fullscreen: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"currentColor\"><path transform=\"translate(0, 960) scale(1, -1)\" d=\"M598 724.667h212v-212h-84v128h-128v84zM726 212.667v128h84v-212h-212v84h128zM214 512.667v212h212v-84h-128v-128h-84zM298 340.667v-128h128v-84h-212v212h84z\"/></svg>",
	fullscreenExit: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"currentColor\"><path transform=\"translate(0, 960) scale(1, -1)\" d=\"M682 596.667h128v-84h-212v212h84v-128zM598 128.667v212h212v-84h-128v-128h-84zM342 596.667v128h84v-212h-212v84h128zM214 256.667v84h212v-212h-84v128h-128z\"/></svg>"
};
var fullscreenSettings = { fullScreen: true };
var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, {
	enumerable: true,
	configurable: true,
	writable: true,
	value
}) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
	for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
	if (__getOwnPropSymbols$2) {
		for (var prop of __getOwnPropSymbols$2(b)) if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
	}
	return a;
};
var FullScreen = class {
	constructor(instance, $LG) {
		this.core = instance;
		this.$LG = $LG;
		this.settings = __spreadValues$2(__spreadValues$2({}, fullscreenSettings), this.core.settings);
		return this;
	}
	init() {
		var _a, _b;
		this.core.registerDefaultIcons(fullscreenDefaultIcons);
		let fullScreen = "";
		if (this.settings.fullScreen) {
			if (!document.fullscreenEnabled && !document.webkitFullscreenEnabled) return;
			else {
				fullScreen = `<button type="button" aria-label="${(_b = (_a = this.settings.fullscreenPluginStrings) == null ? void 0 : _a.toggleFullscreen) != null ? _b : this.core.settings.strings.toggleFullscreen}" class="lg-fullscreen lg-icon"></button>`;
				this.core.$toolbar.append(fullScreen);
				this.fullScreen();
			}
		}
	}
	isFullScreen() {
		return document.fullscreenElement || document.webkitFullscreenElement;
	}
	requestFullscreen() {
		const el = document.documentElement;
		if (el.requestFullscreen) el.requestFullscreen();
		else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
	}
	exitFullscreen() {
		if (document.exitFullscreen) document.exitFullscreen();
		else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
	}
	fullScreen() {
		this.$LG(document).on(`fullscreenchange.lg.global${this.core.lgId} 
            webkitfullscreenchange.lg.global${this.core.lgId}`, () => {
			if (!this.core.lgOpened) return;
			this.core.outer.toggleClass("lg-fullscreen-on");
		});
		this.core.outer.find(".lg-fullscreen").first().on("click.lg", () => {
			if (this.isFullScreen()) this.exitFullscreen();
			else this.requestFullscreen();
		});
	}
	closeGallery() {
		if (this.isFullScreen()) this.exitFullscreen();
	}
	destroy() {
		this.$LG(document).off(`fullscreenchange.lg.global${this.core.lgId} 
            webkitfullscreenchange.lg.global${this.core.lgId}`);
	}
};
//#endregion
//#region ../../../../../node_modules/lightgallery/plugins/video/lg-video.es5.js
/*!
* lightgallery | 3.0.0 | October 9th 2026
* http://www.lightgalleryjs.com/
* Copyright (c) 2020 Sachin Neravath;
* @license GPLv3
*/
var videoSettings = {
	autoplayFirstVideo: true,
	videoFacade: true,
	youTubeNoCookie: true,
	youTubePlayerParams: false,
	vimeoPlayerParams: false,
	wistiaPlayerParams: false,
	gotoNextSlideOnVideoEnd: true,
	autoplayVideoOnSlide: false,
	videojs: false,
	videojsTheme: "",
	videojsOptions: {}
};
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, {
	enumerable: true,
	configurable: true,
	writable: true,
	value
}) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
	for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
	if (__getOwnPropSymbols$1) {
		for (var prop of __getOwnPropSymbols$1(b)) if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
	}
	return a;
};
function toParamsObject(params) {
	return typeof params === "object" && params ? params : {};
}
function param(obj) {
	return Object.keys(obj).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join("&");
}
function paramsToObject(url) {
	return url.slice(1).split("&").map((pair) => pair.split("=")).reduce((obj, pair) => {
		const [key, value] = pair.map(decodeURIComponent);
		if (key) obj[key] = value != null ? value : "";
		return obj;
	}, {});
}
function isYouTubeNoCookie(url) {
	return url.includes("youtube-nocookie.com");
}
function getYouTubeEmbedUrl(videoInfo, playerParamsSettings, srcUrl, preferNoCookie = true) {
	if (!videoInfo.youtube) return;
	const slideUrlParams = videoInfo.youtube[2] ? paramsToObject(videoInfo.youtube[2]) : {};
	const params = __spreadValues$1(__spreadValues$1({
		wmode: "opaque",
		autoplay: 0,
		mute: 1,
		enablejsapi: 1
	}, toParamsObject(playerParamsSettings)), slideUrlParams);
	return `${preferNoCookie || isYouTubeNoCookie(srcUrl) ? "//www.youtube-nocookie.com/" : "//www.youtube.com/"}embed/${videoInfo.youtube[1]}?${param(params)}`;
}
var VIMEO_PLAYER_SCRIPT_URL = "https://player.vimeo.com/api/player.js";
var WISTIA_PLAYER_SCRIPT_URL = "https://fast.wistia.com/assets/external/E-v1.js";
function getVimeoEmbedUrl(videoInfo, playerParamsSettings) {
	if (!videoInfo.vimeo) return;
	let urlParams = videoInfo.vimeo[2] || "";
	let defaultParams = param(__spreadValues$1({
		autoplay: 0,
		muted: 1
	}, toParamsObject(playerParamsSettings)));
	const hash = ((videoInfo.vimeo[0].split("/").pop() || "").split("?")[0] || "").split("#")[0];
	const isPrivate = videoInfo.vimeo[1] !== hash;
	if (isPrivate) urlParams = urlParams.replace(`/${hash}`, "");
	urlParams = urlParams[0] === "?" ? `&${urlParams.slice(1)}` : urlParams || "";
	const privateUrlParams = isPrivate ? `h=${hash}` : "";
	defaultParams = privateUrlParams ? `&${defaultParams}` : defaultParams;
	return `//player.vimeo.com/video/${videoInfo.vimeo[1]}?${privateUrlParams}${defaultParams}${urlParams}`;
}
function getWistiaEmbedUrl(videoInfo, playerParamsSettings) {
	if (!videoInfo.wistia) return;
	const paramsObject = toParamsObject(playerParamsSettings);
	const params = Object.keys(paramsObject).length ? param(paramsObject) : "";
	return `//fast.wistia.net/embed/iframe/${videoInfo.wistia[4]}${params ? `?${params}` : ""}`;
}
var lGEvents = {
	hasVideo: "lgHasVideo",
	slideItemLoad: "lgSlideItemLoad",
	beforeSlide: "lgBeforeSlide",
	afterSlide: "lgAfterSlide",
	posterClick: "lgPosterClick"
};
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
	enumerable: true,
	configurable: true,
	writable: true,
	value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
	for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
	if (__getOwnPropSymbols) {
		for (var prop of __getOwnPropSymbols(b)) if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
	}
	return a;
};
var providerScriptLoads = {};
function loadProviderScript(url) {
	if (!providerScriptLoads[url]) providerScriptLoads[url] = new Promise((resolve) => {
		const script = document.createElement("script");
		script.src = url;
		script.async = true;
		script.onload = () => resolve();
		script.onerror = () => resolve();
		document.head.appendChild(script);
	});
	return providerScriptLoads[url];
}
var Video = class {
	constructor(instance) {
		this.core = instance;
		this.settings = __spreadValues(__spreadValues({}, videoSettings), this.core.settings);
		return this;
	}
	init() {
		this.core.LGel.on(`${lGEvents.hasVideo}.video`, this.onHasVideo.bind(this));
		this.core.LGel.on(`${lGEvents.posterClick}.video`, () => {
			const $el = this.core.getSlideItem(this.core.index);
			this.loadVideoOnPosterClick($el);
		});
		this.core.LGel.on(`${lGEvents.slideItemLoad}.video`, this.onSlideItemLoad.bind(this));
		this.core.LGel.on(`${lGEvents.beforeSlide}.video`, this.onBeforeSlide.bind(this));
		this.core.LGel.on(`${lGEvents.afterSlide}.video`, this.onAfterSlide.bind(this));
	}
	/**
	* @desc Event triggered when a slide is completely loaded
	*
	* @param {Event} event - lightGalley custom event
	*/
	onSlideItemLoad(event) {
		const { isFirstSlide, index } = event.detail;
		if (this.settings.autoplayFirstVideo && isFirstSlide && index === this.core.index) setTimeout(() => {
			this.loadAndPlayVideo(index);
		}, 200);
		if (!isFirstSlide && this.settings.autoplayVideoOnSlide && index === this.core.index) this.loadAndPlayVideo(index);
	}
	/**
	* @desc Event triggered when video url or poster found
	* Append video HTML is poster is not given
	* Play if autoplayFirstVideo is true
	*
	* @param {Event} event - Javascript Event object.
	*/
	onHasVideo(event) {
		const { index, src, html5Video, hasPoster } = event.detail;
		if (!hasPoster) {
			this.appendVideos(this.core.getSlideItem(index), {
				src,
				addClass: "lg-object",
				index,
				html5Video
			});
			this.gotoNextSlideOnVideoEnd(src, index);
		}
	}
	/**
	* @desc fired immediately before each slide transition.
	* Pause the previous video
	* Hide the download button if the slide contains YouTube, Vimeo, or Wistia videos.
	*
	* @param {Event} event - Javascript Event object.
	* @param {number} prevIndex - Previous index of the slide.
	* @param {number} index - Current index of the slide
	*/
	onBeforeSlide(event) {
		if (this.core.lGalleryOn) {
			const { prevIndex } = event.detail;
			this.pauseVideo(prevIndex);
		}
	}
	/**
	* @desc fired immediately after each slide transition.
	* Play video if autoplayVideoOnSlide option is enabled.
	*
	* @param {Event} event - Javascript Event object.
	* @param {number} prevIndex - Previous index of the slide.
	* @param {number} index - Current index of the slide
	* @todo should check on onSlideLoad as well if video is not loaded on after slide
	*/
	onAfterSlide(event) {
		const { index, prevIndex } = event.detail;
		const $slide = this.core.getSlideItem(index);
		if (this.settings.autoplayVideoOnSlide && index !== prevIndex) {
			if ($slide.hasClass("lg-complete")) setTimeout(() => {
				this.loadAndPlayVideo(index);
			}, 100);
		}
	}
	loadAndPlayVideo(index) {
		const $slide = this.core.getSlideItem(index);
		if (this.core.galleryItems[index].poster) this.loadVideoOnPosterClick($slide, true);
		else this.playVideo(index);
	}
	/**
	* Play HTML5, Youtube, Vimeo or Wistia videos in a particular slide.
	* @param {number} index - Index of the slide
	*/
	playVideo(index) {
		this.controlVideo(index, "play");
	}
	/**
	* Pause HTML5, Youtube, Vimeo or Wistia videos in a particular slide.
	* @param {number} index - Index of the slide
	*/
	pauseVideo(index) {
		this.controlVideo(index, "pause");
	}
	getVideoHtml(src, addClass, index, html5Video) {
		let video = "";
		const videoInfo = this.core.galleryItems[index].__slideVideoInfo || {};
		const currentGalleryItem = this.core.galleryItems[index];
		let videoTitle = currentGalleryItem.title || currentGalleryItem.alt;
		videoTitle = videoTitle ? "title=\"" + videoTitle + "\"" : "";
		const commonIframeProps = `allowtransparency="true"
            frameborder="0"
            scrolling="no"
            allowfullscreen
            mozallowfullscreen
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen`;
		if (videoInfo.youtube) {
			const videoId = "lg-youtube" + index;
			const embedUrl = getYouTubeEmbedUrl(videoInfo, this.settings.youTubePlayerParams, src, this.settings.youTubeNoCookie);
			video = `<iframe allow="autoplay" id=${videoId} class="lg-video-object lg-youtube ${addClass}" ${videoTitle} src="${embedUrl}" ${commonIframeProps}></iframe>`;
		} else if (videoInfo.vimeo) {
			const videoId = "lg-vimeo" + index;
			const embedUrl = getVimeoEmbedUrl(videoInfo, this.settings.vimeoPlayerParams);
			video = `<iframe allow="autoplay" id=${videoId} class="lg-video-object lg-vimeo ${addClass}" ${videoTitle} src="${embedUrl}" ${commonIframeProps}></iframe>`;
		} else if (videoInfo.wistia) video = `<iframe allow="autoplay" id="${"lg-wistia" + index}" src="${getWistiaEmbedUrl(videoInfo, this.settings.wistiaPlayerParams)}" ${videoTitle} class="wistia_embed lg-video-object lg-wistia ${addClass}" name="wistia_embed" ${commonIframeProps}></iframe>`;
		else if (videoInfo.html5) {
			let html5VideoMarkup = "";
			for (let i = 0; i < html5Video.source.length; i++) {
				const type = html5Video.source[i].type;
				const typeAttr = type ? `type="${type}"` : "";
				html5VideoMarkup += `<source src="${html5Video.source[i].src}" ${typeAttr}>`;
			}
			if (html5Video.tracks) for (let i = 0; i < html5Video.tracks.length; i++) {
				let trackAttributes = "";
				const track = html5Video.tracks[i];
				Object.keys(track || {}).forEach(function(key) {
					trackAttributes += `${key}="${track[key]}" `;
				});
				html5VideoMarkup += `<track ${trackAttributes}>`;
			}
			let html5VideoAttrs = "";
			const videoAttributes = html5Video.attributes || {};
			Object.keys(videoAttributes || {}).forEach(function(key) {
				html5VideoAttrs += `${key}="${videoAttributes[key]}" `;
			});
			video = `<video class="lg-video-object lg-html5 ${this.settings.videojs && this.settings.videojsTheme ? this.settings.videojsTheme + " " : ""} ${this.settings.videojs ? " video-js" : ""}" ${html5VideoAttrs}>
                ${html5VideoMarkup}
                Your browser does not support HTML5 video.
            </video>`;
		}
		return video;
	}
	/**
	* @desc - Append videos to the slide
	*
	* @param {HTMLElement} el - slide element
	* @param {Object} videoParams - Video parameters, Contains src, class, index, htmlVideo
	*/
	appendVideos(el, videoParams) {
		var _a;
		const videoHtml = this.getVideoHtml(videoParams.src, videoParams.addClass, videoParams.index, videoParams.html5Video);
		el.find(".lg-video-cont").append(videoHtml);
		const $videoElement = el.find(".lg-video-object").first();
		if (videoParams.html5Video) $videoElement.on("mousedown.lg.video", (e) => {
			e.stopPropagation();
		});
		if (this.settings.videojs && ((_a = this.core.galleryItems[videoParams.index].__slideVideoInfo) == null ? void 0 : _a.html5)) try {
			return videojs($videoElement.get(), this.settings.videojsOptions);
		} catch (e) {
			console.error("lightGallery:- Make sure you have included videojs. See https://www.lightgalleryjs.com/demos/video-gallery/");
		}
	}
	gotoNextSlideOnVideoEnd(src, index) {
		const $videoElement = this.core.getSlideItem(index).find(".lg-video-object").first();
		const videoInfo = this.core.galleryItems[index].__slideVideoInfo || {};
		if (this.settings.gotoNextSlideOnVideoEnd) {
			if (videoInfo.html5) $videoElement.on("ended", () => {
				this.core.goToNextSlide();
			});
			else if (videoInfo.vimeo) this.withVimeoApi(() => {
				new Vimeo.Player($videoElement.get()).on("ended", () => {
					this.core.goToNextSlide();
				});
			});
			else if (videoInfo.wistia) this.pushWistiaCommand({
				id: $videoElement.attr("id"),
				onReady: (video) => {
					video.bind("end", () => {
						this.core.goToNextSlide();
					});
				}
			});
		}
	}
	/**
	* Run a callback with the Vimeo player API available, loading
	* player.js on demand at first use (lite-embed: no provider script
	* before user intent). Errors keep the 2.x console message.
	*/
	withVimeoApi(callback) {
		const run = () => {
			try {
				callback();
			} catch (e) {
				console.error("lightGallery:- Make sure you have included //github.com/vimeo/player.js. See https://www.lightgalleryjs.com/demos/video-gallery/");
			}
		};
		if (window.Vimeo && window.Vimeo.Player) {
			run();
			return;
		}
		loadProviderScript(VIMEO_PLAYER_SCRIPT_URL).then(run);
	}
	/**
	* Queue a Wistia command and load E-v1.js on demand, `_wq` is
	* Wistia's own pre-load command queue, drained when the script lands.
	*/
	pushWistiaCommand(command) {
		try {
			window._wq = window._wq || [];
			window._wq.push(command);
		} catch (e) {
			console.error("lightGallery:- Make sure you have included //fast.wistia.com/assets/external/E-v1.js. See https://www.lightgalleryjs.com/demos/video-gallery/");
			return;
		}
		if (!window.Wistia) loadProviderScript(WISTIA_PLAYER_SCRIPT_URL);
	}
	controlVideo(index, action) {
		const $videoElement = this.core.getSlideItem(index).find(".lg-video-object").first();
		const videoInfo = this.core.galleryItems[index].__slideVideoInfo || {};
		if (!$videoElement.get()) return;
		if (videoInfo.youtube) try {
			$videoElement.get().contentWindow.postMessage(`{"event":"command","func":"${action}Video","args":""}`, "*");
		} catch (e) {
			console.error(`lightGallery:- ${e}`);
		}
		else if (videoInfo.vimeo) this.withVimeoApi(() => {
			new Vimeo.Player($videoElement.get())[action]();
		});
		else if (videoInfo.html5) {
			if (this.settings.videojs) try {
				videojs($videoElement.get())[action]();
			} catch (e) {
				console.error("lightGallery:- Make sure you have included videojs. See https://www.lightgalleryjs.com/demos/video-gallery/");
			}
			else $videoElement.get()[action]();
		} else if (videoInfo.wistia) this.pushWistiaCommand({
			id: $videoElement.attr("id"),
			onReady: (video) => {
				video[action]();
			}
		});
	}
	loadVideoOnPosterClick($el, forcePlay) {
		if (!$el.hasClass("lg-video-loaded")) {
			if (!$el.hasClass("lg-has-video")) {
				$el.addClass("lg-has-video");
				let _html;
				const _src = this.core.galleryItems[this.core.index].src;
				const video = this.core.galleryItems[this.core.index].video;
				if (video) _html = typeof video === "string" ? JSON.parse(video) : video;
				const videoJsPlayer = this.appendVideos($el, {
					src: _src,
					addClass: "",
					index: this.core.index,
					html5Video: _html
				});
				this.gotoNextSlideOnVideoEnd(_src, this.core.index);
				const $tempImg = $el.find(".lg-object").first().get();
				$el.find(".lg-video-cont").first().append($tempImg);
				$el.addClass("lg-video-loading");
				videoJsPlayer && videoJsPlayer.ready(() => {
					videoJsPlayer.on("loadedmetadata", () => {
						this.onVideoLoadAfterPosterClick($el, this.core.index);
					});
				});
				$el.find(".lg-video-object").first().on("load.lg error.lg loadedmetadata.lg", () => {
					setTimeout(() => {
						this.onVideoLoadAfterPosterClick($el, this.core.index);
					}, 50);
				});
			} else this.playVideo(this.core.index);
		} else if (forcePlay) this.playVideo(this.core.index);
	}
	onVideoLoadAfterPosterClick($el, index) {
		$el.addClass("lg-video-loaded");
		this.playVideo(index);
	}
	destroy() {
		this.core.LGel.off(".lg.video");
		this.core.LGel.off(".video");
	}
};
//#endregion
//#region ../../styled-system/styled-system/helpers.js
function isObject(v) {
	return typeof v === "object" && v != null && !Array.isArray(v);
}
var HAS_OWN = Object.prototype.hasOwnProperty;
function isBaseCondition(v) {
	return v === "base";
}
function filterBaseConditions(c) {
	const out = [];
	for (let i = 0; i < c.length; i++) if (!isBaseCondition(c[i])) out.push(c[i]);
	return out;
}
function toHash(v) {
	let h = 5381;
	for (let i = v.length; i;) h = h * 33 ^ v.charCodeAt(--i);
	let x = h >>> 0, out = "";
	for (; x > 52; x = x / 52 | 0) {
		const c = x % 52;
		out = String.fromCharCode(c + (c > 25 ? 39 : 97)) + out;
	}
	const c = x % 52;
	return String.fromCharCode(c + (c > 25 ? 39 : 97)) + out;
}
function toResponsiveObject(values, breakpoints) {
	const out = {};
	for (let i = 0; i < values.length; i++) if (values[i] != null) out[breakpoints[i]] = values[i];
	return out;
}
function walkObject(target, fn, options) {
	options ||= {};
	const { stop, getKey } = options;
	const inner = (value, path = []) => {
		if (!value || typeof value !== "object") return fn(value, path);
		if (stop?.(value, path)) return fn(value, path);
		const out = Array.isArray(value) ? [] : {};
		for (const prop in value) {
			if (!HAS_OWN.call(value, prop) || prop === "__proto__") continue;
			const key = getKey?.(prop, value[prop]) ?? prop;
			path.push(key);
			const next = inner(value[prop], path);
			path.pop();
			if (next != null) out[key] = next;
		}
		return out;
	};
	return inner(target);
}
function normalizeStyleObject(styles, context, shorthand) {
	const { utility, conditions } = context;
	const { hasShorthand, resolveShorthand } = utility;
	shorthand = shorthand !== false;
	return walkObject(styles, (value) => {
		if (Array.isArray(value)) return toResponsiveObject(value, conditions.breakpoints.keys);
		return value;
	}, {
		stop: Array.isArray,
		getKey: shorthand ? (prop) => hasShorthand ? resolveShorthand(prop) : prop : void 0
	});
}
function flatHashOrNull(args) {
	let h = 5381;
	for (let a = 0; a < args.length; a++) {
		const obj = args[a];
		if (obj === null || typeof obj !== "object") {
			h = h * 33 ^ 1;
			continue;
		}
		for (const k in obj) {
			const v = obj[k];
			const tv = typeof v;
			if (v !== null && tv === "object") return null;
			for (let i = 0; i < k.length; i++) h = h * 33 ^ k.charCodeAt(i);
			if (tv === "string") for (let i = 0; i < v.length; i++) h = h * 33 ^ v.charCodeAt(i);
			else if (tv === "number") h = h * 33 ^ (v | 0);
			else if (tv === "boolean") h = h * 33 ^ (v ? 991 : 997);
			else h = h * 33 ^ 2;
		}
	}
	return h >>> 0;
}
function flatArgsEqual(a, b) {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) {
		const oa = a[i];
		const ob = b[i];
		if (oa === ob) continue;
		if (oa === null || ob === null || typeof oa !== "object" || typeof ob !== "object") return false;
		let n = 0;
		for (const k in oa) {
			if (oa[k] !== ob[k]) return false;
			n++;
		}
		if (n !== Object.keys(ob).length) return false;
	}
	return true;
}
function memo(fn) {
	const cache = /* @__PURE__ */ new Map();
	const stringCache = /* @__PURE__ */ new Map();
	const seen = /* @__PURE__ */ new WeakSet();
	const newNode = () => ({
		objects: /* @__PURE__ */ new WeakMap(),
		prims: /* @__PURE__ */ new Map(),
		out: void 0,
		has: false
	});
	const root = newNode();
	let lastHash;
	let lastKey;
	let lastValue;
	let hasLast = false;
	let misses = 0;
	const step = (node, v) => {
		if (v !== null && typeof v === "object") {
			let next = node.objects.get(v);
			if (next === void 0) {
				next = newNode();
				node.objects.set(v, next);
			}
			return next;
		}
		let next = node.prims.get(v);
		if (next === void 0) {
			if (node.prims.size > 64) node.prims.clear();
			next = newNode();
			node.prims.set(v, next);
		}
		return next;
	};
	const walk = (node, v) => {
		if (Array.isArray(v)) {
			node = step(node, "\0[");
			for (let i = 0; i < v.length; i++) node = walk(node, v[i]);
			return step(node, "\0]");
		}
		return step(node, v);
	};
	const readWalk = (node, v) => {
		if (node === void 0) return void 0;
		if (Array.isArray(v)) {
			node = node.prims.get("\0[");
			for (let i = 0; i < v.length && node !== void 0; i++) node = readWalk(node, v[i]);
			return node === void 0 ? void 0 : node.prims.get("\0]");
		}
		return v !== null && typeof v === "object" ? node.objects.get(v) : node.prims.get(v);
	};
	const markSeen = (v) => {
		if (Array.isArray(v)) {
			let all = true;
			for (let i = 0; i < v.length; i++) if (!markSeen(v[i])) all = false;
			return all;
		}
		if (v === null || typeof v !== "object") return true;
		if (seen.has(v)) return true;
		seen.add(v);
		return false;
	};
	return ((...args) => {
		let composed = false;
		for (let i = 0; i < args.length; i++) if (Array.isArray(args[i])) {
			composed = true;
			break;
		}
		if (composed) {
			let node = root;
			for (let i = 0; i < args.length && node !== void 0; i++) node = readWalk(node, args[i]);
			if (node !== void 0 && node.has) return node.out;
			const composedKey = JSON.stringify(args);
			let composedOut = hasLast && lastHash === void 0 && composedKey === lastKey ? lastValue : stringCache.get(composedKey);
			if (composedOut === void 0) {
				composedOut = fn(...args);
				stringCache.set(composedKey, composedOut);
				if (stringCache.size > 500) stringCache.delete(stringCache.keys().next().value);
			}
			let reused = false;
			if ((++misses & 3) === 0) {
				reused = true;
				for (let i = 0; i < args.length; i++) if (!markSeen(args[i])) reused = false;
			}
			if (reused) {
				let insert = root;
				for (let i = 0; i < args.length; i++) insert = walk(insert, args[i]);
				insert.out = composedOut;
				insert.has = true;
			}
			lastHash = void 0;
			lastKey = composedKey;
			lastValue = composedOut;
			hasLast = true;
			return composedOut;
		}
		const hash = flatHashOrNull(args);
		if (hash !== null) {
			if (hasLast && lastHash === hash && flatArgsEqual(args, lastKey)) return lastValue;
			let bucket = cache.get(hash);
			if (bucket) {
				for (let i = 0; i < bucket.length; i++) if (flatArgsEqual(args, bucket[i].args)) {
					lastHash = hash;
					lastKey = args;
					lastValue = bucket[i].out;
					hasLast = true;
					return bucket[i].out;
				}
			}
			const out = fn(...args);
			if (!bucket) {
				bucket = [];
				cache.set(hash, bucket);
			}
			bucket.push({
				args,
				out
			});
			if (bucket.length > 8) bucket.shift();
			if (cache.size > 500) cache.delete(cache.keys().next().value);
			lastHash = hash;
			lastKey = args;
			lastValue = out;
			hasLast = true;
			return out;
		}
		const key = JSON.stringify(args);
		if (hasLast && lastHash === void 0 && key === lastKey) return lastValue;
		const cached = stringCache.get(key);
		if (cached !== void 0) {
			lastHash = void 0;
			lastKey = key;
			lastValue = cached;
			hasLast = true;
			return cached;
		}
		const out = fn(...args);
		stringCache.set(key, out);
		if (stringCache.size > 500) stringCache.delete(stringCache.keys().next().value);
		lastHash = void 0;
		lastKey = key;
		lastValue = out;
		hasLast = true;
		return out;
	});
}
function weakMemo(fn) {
	const cache = /* @__PURE__ */ new WeakMap();
	return ((arg) => {
		if (!arg || typeof arg !== "object") return fn(arg);
		if (cache.has(arg)) return cache.get(arg);
		const out = fn(arg);
		cache.set(arg, out);
		return out;
	});
}
function mergeProps(...src) {
	const out = {};
	for (const obj of src) {
		if (!obj) continue;
		for (const k in obj) {
			if (!HAS_OWN.call(obj, k) || k === "__proto__" || k === "constructor" || k === "prototype") continue;
			const prev = out[k];
			const next = obj[k];
			out[k] = isObject(prev) && isObject(next) ? mergeProps(prev, next) : next;
		}
	}
	return out;
}
var WHITESPACE_REGEX = /[\n\s]+/g;
var sanitizeStyleValue = (value) => typeof value === "string" ? value.replace(WHITESPACE_REGEX, " ") : value;
function resolveStyleArgs(styles, context) {
	const out = [];
	const visit = (items) => {
		for (let i = 0; i < items.length; i++) {
			const style = items[i];
			if (Array.isArray(style)) {
				visit(style);
				continue;
			}
			if (!isObject(style)) continue;
			for (const key in style) if (style[key] !== void 0) {
				out.push(style);
				break;
			}
		}
	};
	visit(styles);
	if (out.length < 2) return out;
	for (let i = 0; i < out.length; i++) out[i] = normalizeStyleObject(out[i], context);
	return out;
}
function createSerializeCss(context) {
	const u = context.utility;
	const c = context.conditions;
	const hash = context.hash;
	const fmt = (s) => u.prefix ? u.prefix + "-" + s : s;
	const toClass = (paths, name) => {
		const parts = c.finalize(paths);
		parts.push(hash ? name : fmt(name));
		return hash ? fmt(u.toHash(parts, toHash)) : parts.join(":");
	};
	return weakMemo(memo(function serializeCss({ base, ...styles } = {}) {
		const obj = normalizeStyleObject(base ? Object.assign(styles, base) : styles, context);
		const set = /* @__PURE__ */ new Set();
		walkObject(obj, (value, paths) => {
			if (value == null) return;
			const important = isImportant(value);
			const [prop, ...all] = c.shift(paths);
			const cond = filterBaseConditions(all);
			const res = u.transform(prop, withoutSpace(withoutImportant(sanitizeStyleValue(value))));
			let name = toClass(cond, res.className);
			if (important) name += "!";
			set.add(name);
		});
		let out = "";
		for (const name of set) out += out ? " " + name : name;
		return out;
	}));
}
function createMergeCss(context) {
	return function mergeCss() {
		return mergeProps(...resolveStyleArgs(arguments, context));
	};
}
function createSerializeCssArgs(serializeCss, mergeCss) {
	return memo(function serializeCssArgs(...styles) {
		return serializeCss(mergeCss(...styles));
	});
}
var HYPHENATE_PROPERTY_REGEX = /[A-Z]/g;
var MS_PROPERTY_REGEX = /^ms-/;
function hypenateProperty(property) {
	return property.startsWith("--") ? property : property.replace(HYPHENATE_PROPERTY_REGEX, "-$&").replace(MS_PROPERTY_REGEX, "-ms-").toLowerCase();
}
function withoutSpace(str) {
	return typeof str === "string" && str.indexOf(" ") >= 0 ? str.replaceAll(" ", "_") : str;
}
var IMPORTANT_REGEX = /\s*!(important)?\s*$/i;
function isImportant(value) {
	return typeof value === "string" ? IMPORTANT_REGEX.test(value) : false;
}
function withoutImportant(value) {
	return typeof value === "string" ? value.replace(IMPORTANT_REGEX, "").trim() : value;
}
//#endregion
//#region ../../styled-system/styled-system/css/conditions.js
var conditions = /* @__PURE__ */ new Set(/* @__PURE__ */ "2xl,2xlDown,2xlOnly,2xlToDesktop,2xlToTablet,2xlToXs,@/2xl,@/2xlDown,@/2xlOnly,@/2xlTo3xl,@/2xlTo4xl,@/2xlTo5xl,@/2xlTo6xl,@/2xlTo7xl,@/2xlTo8xl,@/2xs,@/2xsDown,@/2xsOnly,@/2xsTo2xl,@/2xsTo3xl,@/2xsTo4xl,@/2xsTo5xl,@/2xsTo6xl,@/2xsTo7xl,@/2xsTo8xl,@/2xsToLg,@/2xsToMd,@/2xsToSm,@/2xsToXl,@/2xsToXs,@/3xl,@/3xlDown,@/3xlOnly,@/3xlTo4xl,@/3xlTo5xl,@/3xlTo6xl,@/3xlTo7xl,@/3xlTo8xl,@/3xs,@/3xsDown,@/3xsOnly,@/3xsTo2xl,@/3xsTo2xs,@/3xsTo3xl,@/3xsTo4xl,@/3xsTo5xl,@/3xsTo6xl,@/3xsTo7xl,@/3xsTo8xl,@/3xsToLg,@/3xsToMd,@/3xsToSm,@/3xsToXl,@/3xsToXs,@/4xl,@/4xlDown,@/4xlOnly,@/4xlTo5xl,@/4xlTo6xl,@/4xlTo7xl,@/4xlTo8xl,@/5xl,@/5xlDown,@/5xlOnly,@/5xlTo6xl,@/5xlTo7xl,@/5xlTo8xl,@/6xl,@/6xlDown,@/6xlOnly,@/6xlTo7xl,@/6xlTo8xl,@/7xl,@/7xlDown,@/7xlOnly,@/7xlTo8xl,@/8xl,@/8xlDown,@/8xlOnly,@/lg,@/lgDown,@/lgOnly,@/lgTo2xl,@/lgTo3xl,@/lgTo4xl,@/lgTo5xl,@/lgTo6xl,@/lgTo7xl,@/lgTo8xl,@/lgToXl,@/md,@/mdDown,@/mdOnly,@/mdTo2xl,@/mdTo3xl,@/mdTo4xl,@/mdTo5xl,@/mdTo6xl,@/mdTo7xl,@/mdTo8xl,@/mdToLg,@/mdToXl,@/sm,@/smDown,@/smOnly,@/smTo2xl,@/smTo3xl,@/smTo4xl,@/smTo5xl,@/smTo6xl,@/smTo7xl,@/smTo8xl,@/smToLg,@/smToMd,@/smToXl,@/xl,@/xlDown,@/xlOnly,@/xlTo2xl,@/xlTo3xl,@/xlTo4xl,@/xlTo5xl,@/xlTo6xl,@/xlTo7xl,@/xlTo8xl,@/xs,@/xsDown,@/xsOnly,@/xsTo2xl,@/xsTo3xl,@/xsTo4xl,@/xsTo5xl,@/xsTo6xl,@/xsTo7xl,@/xsTo8xl,@/xsToLg,@/xsToMd,@/xsToSm,@/xsToXl,_active,_after,_anyPointerCoarse,_anyPointerFine,_anyPointerNone,_atValue,_autofill,_backdrop,_before,_checked,_closed,_complete,_current,_currentPage,_currentStep,_dark,_default,_disabled,_dragging,_empty,_enabled,_even,_expanded,_file,_first,_firstLetter,_firstLine,_firstOfType,_focus,_focusVisible,_focusWithin,_fullscreen,_grabbed,_groupActive,_groupChecked,_groupDisabled,_groupExpanded,_groupFocus,_groupFocusVisible,_groupFocusWithin,_groupHover,_groupInvalid,_hidden,_highContrast,_highlighted,_horizontal,_hover,_icon,_inRange,_incomplete,_indeterminate,_inert,_invalid,_invertedColors,_landscape,_last,_lastOfType,_lessContrast,_light,_loading,_ltr,_marker,_moreContrast,_motionReduce,_motionSafe,_noscript,_now,_odd,_only,_onlyOfType,_open,_optional,_osDark,_osLight,_outOfRange,_overValue,_peerActive,_peerChecked,_peerDisabled,_peerExpanded,_peerFocus,_peerFocusVisible,_peerFocusWithin,_peerHover,_peerInvalid,_peerPlaceholderShown,_placeholder,_placeholderShown,_pointerCoarse,_pointerFine,_pointerNone,_portrait,_pressed,_print,_rangeEnd,_rangeStart,_readOnly,_readWrite,_required,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_selected,_selection,_starting,_target,_today,_topmost,_unavailable,_underValue,_userInvalid,_userValid,_valid,_vertical,_visited,base,desktop,desktopDown,desktopOnly,lg,lgDown,lgOnly,lgTo2xl,lgToDesktop,lgToTablet,lgToXl,lgToXs,md,mdDown,mdOnly,mdTo2xl,mdToDesktop,mdToLg,mdToTablet,mdToXl,mdToXs,sm,smDown,smOnly,smTo2xl,smToDesktop,smToLg,smToMd,smToTablet,smToXl,smToXs,tablet,tabletDown,tabletOnly,tabletToDesktop,xl,xlDown,xlOnly,xlTo2xl,xlToDesktop,xlToTablet,xlToXs,xs,xsDown,xsOnly,xsToDesktop,xsToTablet".split(","));
var conditionRe = /^@|&/;
var underscoreRe = /^_/;
var selectorRe = /&|@/;
var breakpointKeys = [
	"base",
	"sm",
	"md",
	"lg",
	"xl",
	"2xl",
	"xs",
	"tablet",
	"desktop"
];
function isCondition(v) {
	return conditions.has(v) || conditionRe.test(v);
}
function finalizeConditions(paths) {
	return paths.map((p) => {
		if (conditions.has(p)) return p.replace(underscoreRe, "");
		if (selectorRe.test(p)) return `[${withoutSpace(p.trim())}]`;
		return p;
	});
}
function sortConditions(paths) {
	return [...paths].sort((a, b) => {
		const aa = isCondition(a);
		const bb = isCondition(b);
		return aa && !bb ? 1 : !aa && bb ? -1 : 0;
	});
}
//#endregion
//#region ../../styled-system/styled-system/css/css.js
var utilities = "WebkitTextFillColor:wktf-c,accentColor:ac-c,alignContent:ac,alignItems:ai,alignSelf:as,animation:anim,animationComposition:anim-comp,animationDelay:anim-dly,animationDirection:anim-dir,animationDuration:anim-dur,animationFillMode:anim-fm,animationIterationCount:anim-ic,animationName:anim-n,animationPlayState:anim-ps,animationRange:anim-r,animationRangeEnd:anim-re,animationRangeStart:anim-rs,animationState:anim-s,animationTimeline:anim-tl,animationTimingFunction:anim-tmf,appearance:ap,aspectRatio:asp,backdropBlur:bkdp-blur,backdropBrightness:bkdp-brightness,backdropContrast:bkdp-contrast,backdropFilter:bkdp,backdropGrayscale:bkdp-grayscale,backdropHueRotate:bkdp-hue-rotate,backdropInvert:bkdp-invert,backdropOpacity:bkdp-opacity,backdropSaturate:bkdp-saturate,backdropSepia:bkdp-sepia,backfaceVisibility:bfv,background:bg/1,backgroundAttachment:bg-a/bgAttachment,backgroundBlendMode:bg-bm/bgBlendMode,backgroundClip:bg-cp/bgClip,backgroundColor:bg-c/bgColor,backgroundConic:bg-conic/bgConic,backgroundGradient:bg-grad/bgGradient,backgroundImage:bg-i/bgImage,backgroundLinear:bg-linear/bgLinear,backgroundOrigin:bg-o/bgOrigin,backgroundPosition:bg-p/bgPosition,backgroundPositionX:bg-p-x/bgPositionX,backgroundPositionY:bg-p-y/bgPositionY,backgroundRadial:bg-radial/bgRadial,backgroundRepeat:bg-r/bgRepeat,backgroundSize:bg-s/bgSize,blockSize:h-bs,border:bd,borderBlock:bd-y/borderY,borderBlockColor:bd-y-c/borderYColor,borderBlockEnd:bd-be,borderBlockEndColor:bd-be-c,borderBlockEndWidth:bd-be-w,borderBlockStart:bd-bs,borderBlockStartColor:bd-bs-c,borderBlockStartWidth:bd-bs-w,borderBlockWidth:bd-y-w/borderYWidth,borderBottom:bd-b,borderBottomColor:bd-b-c,borderBottomLeftRadius:bdr-bl/roundedBottomLeft,borderBottomRadius:bdr-b/roundedBottom,borderBottomRightRadius:bdr-br/roundedBottomRight,borderBottomWidth:bd-b-w,borderCollapse:bd-cl,borderColor:bd-c,borderEndEndRadius:bdr-ee/roundedEndEnd,borderEndRadius:bdr-e/roundedEnd,borderEndStartRadius:bdr-es/roundedEndStart,borderInline:bd-x/borderX,borderInlineColor:bd-x-c/borderXColor,borderInlineEnd:bd-e/borderEnd,borderInlineEndColor:bd-e-c/borderEndColor,borderInlineEndWidth:bd-e-w/borderEndWidth,borderInlineStart:bd-s/borderStart,borderInlineStartColor:bd-s-c/borderStartColor,borderInlineStartWidth:bd-s-w/borderStartWidth,borderInlineWidth:bd-x-w/borderXWidth,borderLeft:bd-l,borderLeftColor:bd-l-c,borderLeftRadius:bdr-l/roundedLeft,borderLeftWidth:bd-l-w,borderRadius:bdr/rounded,borderRight:bd-r,borderRightColor:bd-r-c,borderRightRadius:bdr-r/roundedRight,borderRightWidth:bd-r-w,borderSpacing:bd-sp,borderSpacingX:bd-sx,borderSpacingY:bd-sy,borderStartEndRadius:bdr-se/roundedStartEnd,borderStartRadius:bdr-s/roundedStart,borderStartStartRadius:bdr-ss/roundedStartStart,borderTop:bd-t,borderTopColor:bd-t-c,borderTopLeftRadius:bdr-tl/roundedTopLeft,borderTopRadius:bdr-t/roundedTop,borderTopRightRadius:bdr-tr/roundedTopRight,borderTopWidth:bd-t-w,borderWidth:bd-w,boxDecorationBreak:bx-db,boxShadow:bx-sh/shadow,boxShadowColor:bx-sh-c/shadowColor,boxSize:size,boxSizing:bx-s,caretColor:ca-c,clipPath:cp-path,color:c,columnGap:cg,container:cq,containerName:cq-n,containerType:cq-t,display:d,divideColor:dvd-c,divideStyle:dvd-s,divideX:dvd-x,divideY:dvd-y,flexBasis:flex-b,flexDirection:flex-d/flexDir,flexGrow:flex-g,flexShrink:flex-sh,focusRingColor:focus-ring-c,focusRingOffset:focus-ring-o,focusRingStyle:focus-ring-s,focusRingWidth:focus-ring-w,focusVisibleRing:focus-v-ring,fontFamily:ff,fontFeatureSettings:ff-s,fontKerning:fk,fontPalette:fp,fontSize:fs,fontSizeAdjust:fs-a,fontSmoothing:fsmt,fontVariant:fv,fontVariantAlternates:fv-alt,fontVariantCaps:fv-caps,fontVariantNumeric:fv-num,fontVariationSettings:fv-s,fontWeight:fw,gradientFrom:grad-from,gradientFromPosition:grad-from-pos,gradientTo:grad-to,gradientToPosition:grad-to-pos,gradientVia:grad-via,gradientViaPosition:grad-via-pos,gridAutoColumns:grid-ac,gridAutoFlow:grid-af,gridAutoRows:grid-ar,gridColumn:grid-c,gridColumnEnd:grid-ce,gridColumnGap:grid-cg,gridColumnStart:grid-cs,gridGap:grid-g,gridRow:grid-r,gridRowGap:grid-rg,gridTemplateColumns:grid-tc,gridTemplateRows:grid-tr,height:h/1,hideBelow:show,hideFrom:hide,hyphens:hy,inlineSize:w-is,insetBlock:inset-y/insetY,insetBlockEnd:inset-be,insetBlockStart:inset-bs,insetInline:inset-x/insetX,insetInlineEnd:inset-e/end/insetEnd,insetInlineStart:inset-s/insetStart/start,justifyContent:jc,letterSpacing:ls,lineClamp:lc,lineHeight:lh,listStyle:li-s,listStyleImage:li-img,listStylePosition:li-pos,listStyleType:li-t,margin:m/1,marginBlock:my/marginY/1,marginBlockEnd:mbe,marginBlockStart:mbs,marginBottom:mb/1,marginInline:mx/marginX/1,marginInlineEnd:me/marginEnd/1,marginInlineStart:ms/marginStart/1,marginLeft:ml/1,marginRight:mr/1,marginTop:mt/1,mask:msk,maskBottomFrom:msk-b-from,maskBottomFromColor:msk-b-from-c,maskBottomTo:msk-b-to,maskBottomToColor:msk-b-to-c,maskClip:msk-cp,maskComposite:msk-cmp,maskConic:msk-conic,maskConicFrom:msk-conic-from,maskConicFromColor:msk-conic-from-c,maskConicTo:msk-conic-to,maskConicToColor:msk-conic-to-c,maskImage:msk-i,maskLeftFrom:msk-l-from,maskLeftFromColor:msk-l-from-c,maskLeftTo:msk-l-to,maskLeftToColor:msk-l-to-c,maskLinear:msk-linear,maskLinearFrom:msk-linear-from,maskLinearFromColor:msk-linear-from-c,maskLinearTo:msk-linear-to,maskLinearToColor:msk-linear-to-c,maskMode:msk-md,maskOrigin:msk-o,maskPosition:msk-p,maskRadial:msk-radial,maskRadialAt:msk-radial-at,maskRadialFrom:msk-radial-from,maskRadialFromColor:msk-radial-from-c,maskRadialShape:msk-radial-shape,maskRadialSize:msk-radial-sz,maskRadialTo:msk-radial-to,maskRadialToColor:msk-radial-to-c,maskRepeat:msk-r,maskRightFrom:msk-r-from,maskRightFromColor:msk-r-from-c,maskRightTo:msk-r-to,maskRightToColor:msk-r-to-c,maskSize:msk-s,maskTopFrom:msk-t-from,maskTopFromColor:msk-t-from-c,maskTopTo:msk-t-to,maskTopToColor:msk-t-to-c,maskType:msk-t,maskXFrom:msk-x-from,maskXFromColor:msk-x-from-c,maskXTo:msk-x-to,maskXToColor:msk-x-to-c,maskYFrom:msk-y-from,maskYFromColor:msk-y-from-c,maskYTo:msk-y-to,maskYToColor:msk-y-to-c,maxBlockSize:max-b,maxHeight:max-h/maxH,maxInlineSize:max-w-is,maxWidth:max-w/maxW,minBlockSize:min-h-bs,minHeight:min-h/minH,minInlineSize:min-w-is,minWidth:min-w/minW,mixBlendMode:mix-bm,objectFit:obj-f,objectPosition:obj-p,opacity:op,outline:ring/1,outlineColor:ring-c/ringColor,outlineOffset:ring-o/ringOffset,outlineWidth:ring-w/ringWidth,overflow:ov,overflowAnchor:ov-a,overflowBlock:ov-b,overflowClipBox:ovcp-bx,overflowClipMargin:ovcp-m,overflowInline:ov-i,overflowWrap:ov-wrap,overflowX:ov-x,overflowY:ov-y,overscrollBehavior:ovs-b,overscrollBehaviorBlock:ovs-bb,overscrollBehaviorInline:ovs-bi,overscrollBehaviorX:ovs-bx,overscrollBehaviorY:ovs-by,padding:p/1,paddingBlock:py/paddingY/1,paddingBlockEnd:pbe,paddingBlockStart:pbs,paddingBottom:pb/1,paddingInline:px/paddingX/1,paddingInlineEnd:pe/paddingEnd/1,paddingInlineStart:ps/paddingStart/1,paddingLeft:pl/1,paddingRight:pr/1,paddingTop:pt/1,position:pos/1,rowGap:rg,scrollBehavior:scr-bhv,scrollMargin:scr-m,scrollMarginBlock:scr-my/scrollMarginY,scrollMarginBlockEnd:scr-mbe,scrollMarginBlockStart:scr-mbt,scrollMarginBottom:scr-mb,scrollMarginInline:scr-mx/scrollMarginX,scrollMarginInlineEnd:scr-me,scrollMarginInlineStart:scr-ms,scrollMarginLeft:scr-ml,scrollMarginRight:scr-mr,scrollMarginTop:scr-mt,scrollPadding:scr-p,scrollPaddingBlock:scr-py/scrollPaddingY,scrollPaddingBlockEnd:scr-pbe,scrollPaddingBlockStart:scr-pbs,scrollPaddingBottom:scr-pb,scrollPaddingInline:scr-px/scrollPaddingX,scrollPaddingInlineEnd:scr-pe,scrollPaddingInlineStart:scr-ps,scrollPaddingLeft:scr-pl,scrollPaddingRight:scr-pr,scrollPaddingTop:scr-pt,scrollSnapAlign:scr-sa,scrollSnapCoordinate:scrs-c,scrollSnapDestination:scrs-d,scrollSnapMargin:scrs-m,scrollSnapMarginBottom:scrs-mb,scrollSnapMarginLeft:scrs-ml,scrollSnapMarginRight:scrs-mr,scrollSnapMarginTop:scrs-mt,scrollSnapPointsX:scrs-px,scrollSnapPointsY:scrs-py,scrollSnapStop:scrs-s,scrollSnapStrictness:scrs-strt,scrollSnapType:scrs-t,scrollSnapTypeX:scrs-tx,scrollSnapTypeY:scrs-ty,scrollTimeline:scrtl,scrollTimelineAxis:scrtl-a,scrollTimelineName:scrtl-n,scrollbar:scr-bar,scrollbarColor:scr-bar-c,scrollbarGutter:scr-bar-g,scrollbarThumb:scr-bar-th,scrollbarTrack:scr-bar-tk,scrollbarWidth:scr-bar-w,spaceX:sx,spaceY:sy,srOnly:sr,stroke:stk,strokeDasharray:stk-dsh,strokeDashoffset:stk-do,strokeLinecap:stk-lc,strokeLinejoin:stk-lj,strokeMiterlimit:stk-ml,strokeOpacity:stk-op,strokeWidth:stk-w,tableLayout:tbl,textAlign:ta,textDecoration:td,textDecorationColor:td-c,textDecorationStyle:td-s,textDecorationThickness:td-t,textEmphasisColor:te-c,textGradient:txt-grad,textIndent:ti,textOverflow:tov,textShadow:tsh,textShadowColor:tsh-c/textShadowColor,textSizeAdjust:txt-adj,textStyle:textStyle,textTransform:tt,textUnderlineOffset:tu-o,textWrap:tw,touchAction:tch-a,transform:trf,transformBox:trf-b,transformOrigin:trf-o,transformStyle:trf-s,transition:trs,transitionDelay:trs-dly,transitionDuration:trs-dur,transitionProperty:trs-prop,transitionTimingFunction:trs-tmf,translateX:/x,translateY:/y,translateZ:/z,truncate:trunc,userSelect:us,verticalAlign:va,visibility:vis,width:w/1,wordBreak:wb,zIndex:z";
function createCssContext() {
	const classNameByProp = /* @__PURE__ */ new Map();
	const shorthands = /* @__PURE__ */ new Map();
	utilities.split(",").forEach((utility) => {
		const [prop, meta] = utility.split(":");
		const [className, ...shorthandList] = meta.split("/");
		if (className) classNameByProp.set(prop, className);
		shorthandList.forEach((shorthand) => {
			const key = shorthand === "1" ? className : shorthand;
			shorthands.set(key, prop);
		});
	});
	const resolveShorthand = (prop) => shorthands.get(prop) || prop;
	return {
		hash: true,
		conditions: {
			shift: sortConditions,
			finalize: finalizeConditions,
			breakpoints: { keys: breakpointKeys }
		},
		utility: {
			prefix: null,
			hasShorthand: true,
			toHash(path, hashFn) {
				return hashFn(path.join(":"));
			},
			transform(prop, value) {
				const key = resolveShorthand(prop);
				return { className: `${classNameByProp.get(key) || hypenateProperty(key)}_${withoutSpace(value)}` };
			},
			resolveShorthand
		}
	};
}
var cssContext = /* @__PURE__ */ createCssContext();
var serializeCss = /* @__PURE__ */ createSerializeCss(cssContext);
var mergeCss = /* @__PURE__ */ createMergeCss(cssContext);
var serializeCssArgs = /* @__PURE__ */ createSerializeCssArgs(serializeCss, mergeCss);
var css = /* @__PURE__ */ Object.assign(function css(...styles) {
	if (styles.length === 1 && isObject(styles[0])) return serializeCss(styles[0]);
	return serializeCssArgs(...styles);
}, { raw: function cssRaw(...styles) {
	return mergeCss(...styles);
} });
//#endregion
//#region src/lightgallery.tsx
var plugins = [
	Thumbnail,
	Zoom,
	Video,
	FullScreen,
	Hash
];
var LightGalleryContext = createContext({ galleries: {} });
/**
* The `lightgallery` third-party wrapper can throw during teardown when React
* has already detached its DOM nodes (e.g. `removeChild ... parentNode is null`),
* typically after a hydration mismatch forces a client-side subtree regeneration.
* That throw would otherwise bubble to the top-level app ErrorBoundary and blank
* the whole page. This boundary contains the failure locally and degrades to the
* bare gallery content (no lightbox) instead. Scoped to the gallery layer only.
*/
var LightGalleryErrorBoundary = class extends Component {
	state = { hasError: false };
	static getDerivedStateFromError() {
		return { hasError: true };
	}
	componentDidCatch(error, info) {}
	render() {
		return this.state.hasError ? this.props.fallback : this.props.children;
	}
};
function LightGallery({ id, children, elementClassNames, onInit, ...props }) {
	const container = useRef(null);
	const gallery = useRef(void 0);
	const parentContext = useContext(LightGalleryContext);
	const providerValue = useMemo(() => ({ galleries: {
		...parentContext ? parentContext.galleries : {},
		[id]: gallery
	} }), [
		gallery,
		id,
		parentContext
	]);
	const settingsRef = useRef(null);
	if (settingsRef.current === null) settingsRef.current = {
		plugins,
		licenseKey: "LIG0000-0000-000-0000",
		galleryId: id,
		selector: `a[data-gallery='${id}']`,
		download: false,
		exThumbImage: "data-thumbnail",
		hash: true,
		thumbnail: true,
		zoom: true,
		fullScreen: true,
		animateThumb: true,
		...props
	};
	useEffect(() => {
		const el = container.current;
		if (!el) return;
		const instance = lightGallery(el, settingsRef.current ?? {});
		gallery.current = instance;
		onInit?.({ instance });
		return () => {
			gallery.current = void 0;
			try {
				instance.destroy();
			} catch (error) {}
		};
	}, [id]);
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(Style, { style: "core-ui/lightgallery" }), /* @__PURE__ */ jsx(LightGalleryErrorBoundary, {
		fallback: children,
		children: /* @__PURE__ */ jsx("div", {
			ref: container,
			className: Array.isArray(elementClassNames) ? elementClassNames.join(" ") : elementClassNames,
			children: /* @__PURE__ */ jsx(LightGalleryContext.Provider, {
				value: providerValue,
				children
			})
		})
	})] });
}
/**
* `refresh()` reaches into lightGallery internals and can throw when the
* instance is mid-teardown or its DOM has already been detached by React.
* Swallow it: a failed refresh must never propagate up and blank the page.
*/
function safeRefresh(gallery) {
	try {
		gallery.refresh();
	} catch (error) {}
}
function LightGalleryItem({ id, children, name, src, thumbnail, downloadFileName, downloadUrl, width, isVideo = false, css: cssFromProp }) {
	const context = useContext(LightGalleryContext);
	const props = useMemo(() => {
		return {
			"data-gallery": id,
			...name ? {
				alt: name,
				title: name
			} : {},
			...downloadUrl ? { "data-download-url": downloadUrl } : {},
			...downloadFileName ? { "data-download": downloadFileName } : {},
			...width ? { "data-width": width } : {},
			...isVideo ? { "data-video": src } : { "data-src": src },
			...thumbnail ? { "data-thumbnail": thumbnail } : {}
		};
	}, [
		id,
		downloadFileName,
		downloadUrl,
		name,
		src,
		isVideo,
		width,
		thumbnail
	]);
	useEffect(() => {
		const gallery = context?.galleries[id]?.current;
		if (gallery && src) safeRefresh(gallery);
		return () => {
			if (gallery) safeRefresh(gallery);
		};
	}, [
		context?.galleries,
		id,
		src
	]);
	if (!context?.galleries[id] || !src) return children;
	return /* @__PURE__ */ jsx("a", {
		href: src,
		className: css({ textDecoration: "none" }, cssFromProp),
		...props,
		children
	});
}
//#endregion
export { LightGallery, LightGalleryItem };
